import { IAddReferenceData } from "app/schemas/getShipment/GetShipment.schema";
import Environment from "../environments/base.environment";
import { ISortOption } from "../schemas/Home/Home.schema";
import { IUPLOAD_DOCUMENT_CONFIG_FALLBACK, LATE_REASONCODE_MODAL_CONFIG, EUSER_ROLES } from "./AllInterface";

export const APP_VERSION = "25.2.10";

/* 
Configurational Values for Application version to update and navigate to respective app stores if needed.
*/
export enum FirebaseRemoteConfiguration {
  REMOTECONFIG_STORE_VERSION = "store_version",
  APPLESTORE_REDIRECTURL = "itms-apps://itunes.apple.com/app/id1531879145",
  PLAYSTORE_REDIRECTURL = "market://details?id=com.schneider.fp.carrier",
}

/* 
Firebase AB testing Keys. Using this Firebase Remote config Key/Value remotely App data can be changed.
*/ 
export const AB_TEST_KEYS = [
  "APP_INIT",
  "book_now",
  "default_dates_offset_lookup",
  "dispatcher_error_page",
  "driver_error_page",
  "get_qualified",
  "hard_reload_config",
  "non_manage_equipment_alignment",
  "similar_loads",
  "trailer_lease_modal"
];

export enum APP_UPDATE_ALERT {
  TITLE = "App Update Available",
  MESSAGE = "A new version of this app is available. Do you want to apply this update?",
  OK = "Update Now",
  CANCEL = "Later",
  UPDATE_NOW = "Update Now",
  IGNORE_NOW = "Ignore Now"
}

export enum APP_DOWNLOAD_ALERT {
  INSTALL_NOW = "Install Now",
  CANCEL = "Cancel"
}
export enum PERMISSION_REQUEST_ALERT {
  REDIRECT_TO_SETTINGS_MESSAGE = 'Location tracking is required so that we can automatically track the shipments, trigger workflow events on your behalf while the app is in use or backgrounded. Please enable "Always" in the Location Services Settings for the application.',
  REDIRECT_TO_SETTINGS_TITLE = "GPS tracking",
  SETTINGS = "Settings",
  CANCEL = "Cancel"
}
export const FPC_FCM_DUMMY_URL = "https://freightpower.schneider.com/carrier";
export const FPC_DYNAMIC_LINK = "https://schneiderfreightpowercarrier.page.link/a3h6";
export const COMPATIBILE_WIDTH = 768;
export const RESOLUTION_INCOMPATIBLE_MESSAGE =
  "Schneider FreightPower is optimized for resolution larger than 768 width. For best experience we suggest updating your settings before proceeding to the site.";
export const PLATFORM_INCOMPATIBLE_MESSAGE =
  "Schneider FreightPower offers a mobile app which is optimized for this device. Download in your app store by clicking the link below.";
export const MOBILE_PAYMENT_LINK = "https://schneiderfreightpowercarrier.page.link/JVCY";
export const WEB_PAYMENT_LINK = "https://schneiderfreightpowercarrier.page.link/GjbS";
export const RELOAD_OFFSET = {
  originDateDefaultOffset: "2",
  destinationDateDefaultOffset: "8"
};
export const FUEL_SAVING = {
  "redirectionLink" : "https://schneiderfreightpowercarrier.page.link/Yp2y",
}
export const carrierProErrorLabelFallback =  "Kindly provide Carrier Pro";
export const duplicateCarrierProError =  "Carrier Pro already exist";
/** LPE Feedback Events  */

export const LPE_FEEDBACK_EVENTS = "LPE_FEEDBACK_EVENTS";

/* Remote Config Ends */

export const RESTART_ON_REMOUNT = "@@saga-injector/restart-on-remount";
export const DAEMON = "@@saga-injector/daemon";
export const ONCE_TILL_UNMOUNT = "@@saga-injector/once-till-unmount";

export const LAST_UPDATED_DATE = "LAST_UPDATED_DATE";
export const TOGGLE_LOADING = "TOGGLE_LOADING";

export const OFFLINE_MODE_START = "OFFLINE_MODE_START";
export const CREATE_OFFLINE_JSON = "CREATE_OFFLINE_JSON";
export const GET_CONFIG_PARAMS = "GET_CONFIG_PARAMS";
export const UPDATE_OFFLINE_CONTENT = "UPDATE_OFFLINE_CONTENT";
export const FIND_SEARCH_DATA = "FIND_SEARCH_DATA";
export const FIND_SHIPMENT_INFO = "FIND_SHIPMENT_INFO";
export const UPDATE_SEARCH_PARAMS_OFFLINE = "UPDATE_SEARCH_PARAMS_OFFLINE";
export const UPDATE_SHIPMENT_INFO_OFFLINE = "UPDATE_SHIPMENT_INFO_OFFLINE";
export const UPDATE_SEARCH_PARAMS_REDUX = "UPDATE_SEARCH_PARAMS_REDUX";
export const UPDATE_PULL_TO_REFRESH_STATE = "UPDATE_PULL_TO_REFRESH_STATE";
export const STORE_ACCESS_TOKEN = "STORE_ACCESS_TOKEN";
export const STORE_SEGMENT_SELECTED = "STORE_SEGMENT_SELECTED";
export const GET_STATE_COUNTRY_CODES = "GET_STATE_COUNTRY_CODES";
export const LOAD_STATE_COUNTRY_CODES = "LOAD_STATE_COUNTRY_CODES";
export const UPDATE_DATE_OFFSET = "UPDATE_DATE_OFFSET";

export const LOGIN_INPROGRESS = "LOGIN_INPROGRESS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const FETCH_USER_DETAILS = "FETCH_USER_DETAILS";
export const FETCH_USER_DETAILS_SUCCESS = "FETCH_USER_DETAILS_SUCCESS";
export const FETCH_USER_DETAILS_FAILED = "FETCH_USER_DETAILS_FAILED";
export const FETCH_USER_DETAILS_NEW_SUCCESS = "FETCH_USER_DETAILS_NEW_SUCCESS";
export const FETCH_USER_DETAILS_NEW_FAILED = "FETCH_USER_DETAILS_NEW_FAILED";

export const FETCH_USER_DETAILS_NEW = "FETCH_USER_DETAILS_NEW";

export const LOGOUT = "LOGOUT";

export const SESSION = "SESSION";
export const GENERIC_FAILURE_MESSAGE: string = "Something went wrong. Please try again later."

export const UPDATE_DATA = "UPDATE_DATA";
export const WATCHEDLOAD_DATA_REQUEST = "WATCHEDLOAD_DATA_REQUEST";
export const WATCHEDLOAD_DATA_SUCCESS = "WATCHED_DATA_SUCCESS";
export const LOAD_DATA = "LOAD_DATA";
export const SEARCH_DATA = "SEARCH_DATA";
export const STOF_DATA = "STOF_DATA";
export const LOAD_ALL_SEARCH_DATA = "LOAD_ALL_SEARCH_DATA";
export const SAVE_ALL_SEARCH_DATA = "SAVE_ALL_SEARCH_DATA";
export const RECENT_LOADS = "RECENT_LOADS";
export const GET_RECENT = "GET_RECENT";
export const FAVORITE_LOADS = "FAVORITE_LOADS";
export const FAVORITE_LOADS_DATA = "FAVORITE_LOADS_DATA";
export const UPDATE_FAVORITE_LOADS = "UPDATE_FAVORITE_LOADS";
export const GET_FAVORITE = "GET_FAVORITE";
export const UPDATE_FAVORITE_LOADS_REDUCER = "UPDATE_FAVORITE_LOADS_REDUCER";
export const UPDATE_FAVORITE_ERROR = "UPDATE_FAVORITE_ERROR";
export const CLEAR_FAVORITE_ERROR = "CLEAR_FAVORITE_ERROR";
export const PROFILE_IMAGE_SET = "PROFILE_IMAGE_SET";
export const MANAGE_CARD_DATA = "MANAGE_CARD_DATA";
export const GET_MANAGE_CARD_DATA = "GET_MANAGE_CARD_DATA";
export const CARRIER_MANAGE_DATA_REQUEST = "CARRIER_MANAGE_DATA_REQUEST";
export const CARRIER_MANAGE_DATA_SUCCESS = "CARRIER_MANAGE_DATA_SUCCESS";
export const CARRIER_MANAGE_DATA_FAILURE = "CARRIER_MANAGE_DATA_FAILURE";
export const PERMISSION_ALERT_MESSAGE = "PERMISSION_ALERT_MESSAGE";
export const MYLOAD_CARD_DATA = "MYLOAD_CARD_DATA";
export const GET_MYLOAD_CARD_DATA = "GET_MYLOAD_CARD_DATA";
export const CLOSE_PERMISSION_ALERT = "CLOSE_PERMISSION_ALERT";
export const GET_CARRIER_CONTACT_DATA = "GET_CARRIER_CONTACT_DATA";
export const CARRIER_CONTACT_DATA = "CARRIER_CONTACT_DATA";
export const HIDE_TAB_BAR = "HIDE_TAB_BAR";
export const GET_HIDE_TAB_BAR = "GET_HIDE_TAB_BAR";
export const SET_LOAD_FOR_ASSIGN_DRIVER = "SET_LOAD_FOR_ASSIGN_DRIVER";

export const UPDATE_GPS_COORDS = "UPDATE_GPS_COORDS";
export const UPDATE_NETWORK_STATUS = "UPDATE_NETWORK_STATUS";
export const UPDATE_DEVICE_INFO = "UPDATE_DEVICE_INFO";

export const IN_PROGRESS_TEXT = "In Progress";

export const GPS_TIME = 30000;

export const USER_PROFILE_DATA = "USER_PROFILE_DATA";
export const GET_USER_PROFILE_DATA = "GET_USER_PROFILE_DATA";
export const VALIDATE_MOBILE_NUMBER = "VALIDATE_MOBILE_NUMBER";
export const VALIDATE_MOBILE_NUMBER_SUCCESS = "VALIDATE_MOBILE_NUMBER_SUCCESS";
export const VALIDATE_MOBILE_NUMBER_FAILED = "VALIDATE_MOBILE_NUMBER_FAILED";

export const SHOW_TOASTER_VALUE = "SHOW_TOASTER_VALUE";
export const TOKEN_DATA = "TOKEN_DATA";
export const SAVE_DEEPLINK_URI = "SAVE_DEEPLINK_URI";
export const CLEAR_DEEPLINK_URI = "CLEAR_DEEPLINK_URI";
export const DEEPLINK_CLEANUP = "DEEPLINK_CLEANUP";

export const Anywhere = "Anywhere";
export const ANYWHERE = "anywhere";
export const DryVan = "Dry Van";
export const Dray = "Dray";
export const PickUpdateError = "Please provide a correct pickup date.";
export const dropUpdateError = "Please provide correct delivery date";
export const dropdateError1 =
  "Delivery Date Range cannot begin earlier than Pick-Up Date Range.";
export const dropdateError2 =
  "Delivery Date Range cannot end earlier than Pick-Up Date Range.";
export const CityError = "Kindly provide your city name";
export const PickupError = "Please provide a pickup location.";
export const DropoffError = "Please provide a drop off location.";
export const StateSelectionError =
  "The selection of one or more states is required.";

export const RequiredField = "Field is required";
export const OriginRadius = "originRadius";
export const DestinationRadius = "destinationRadius";
export const PickUpdate = "pickUpdate";
export const pickUpStartDate = "pickUpStartDate";
export const PickupDateSerachResults = "Pickup Date";
export const Dropdate = "dropdate";
export const Origin = "origin";
export const Destination = "destination";
export const Trailer = "TrailerType";
export const NewHeader =
  "Enter criteria and click apply to see matching loads.";
export const None = "None";

export const AddFavorite = "Add as Favorite";
export const addDriverHeader = "Carry and update the status of loads";
export const ASSIGN_DRIVER = "ASSIGN_DRIVER";
export const ASSIGN_DRIVER_LIST = "ASSIGN_DRIVER_LIST";
export const TT_ELD_SIGNUP = "TT_ELD_SIGNUP";
export const TT_ELD_SIGNUP_LIST = "TT_ELD_SIGNUP_LIST";
export const FETCH_SEARCH_RESULTS = "FETCH_SEARCH_RESULTS";
export const CLEAR_SEARCH_RESULTS = "CLEAR_SEARCH_RESULTS";
export const ADD_DRIVER_SUCCESS = "ADD_DRIVER_SUCCESS";

export const LOCATION_TRACKER = "LOCATION_TRACKER";
export const LOCATION_TRACKER_RESULTS = "LOCATION_TRACKER_RESULTS";

export const REMOVE_DRIVER_UNASSIGNED_LOAD = "REMOVE_DRIVER_UNASSIGNED_LOAD";
export const GLOBAL_SEARCH_LOADS_UPDATE = "GLOBAL_SEARCH_LOADS_UPDATE";

export const USER_ID = "133444";
export const CARRIER_ID = "SL0977";
export const SHIPMENT_ID = "SDF9864";
export const DEVICE_ID = "iPhone 11";
export const MOBILE = "mobile";
export const FETCH_CARRIER_ASSIGNED_LOADS = "FETCH_CARRIER_ASSIGNED_LOADS";
export const LOAD_CARRIER_DATA = "LOAD_CARRIER_DATA";
export const ACCEPT_LOAD_DATA = "ACCEPT_LOAD_DATA";
export const DECLINE_LOAD_DATA = "DECLINE_LOAD_DATA";
export const LOAD_DELIVEREDNEEDSPPWK_DATA = "LOAD_DELIVEREDNEEDSPPWK_DATA";
export const LOAD_DELIVEREDWITHPPWK_DATA = "LOAD_DELIVEREDWITHPPWK_DATA";
export const LOAD_CARRIERTENDERED_DATA = "LOAD_CARRIERTENDERED_DATA";
export const LOAD_DRIVER_DATA_MANAGE_USERS = "LOAD_DRIVER_DATA_MANAGE_USERS";

export const FETCH_DRIVER_ASSIGNED_LOADS = "FETCH_DRIVER_ASSIGNED_LOADS";
export const DRIVER_ASSIGNED_DATA = "DRIVER_ASSIGNED_DATA";
export const FETCH_MYLOADS = "FETCH_MYLOADS";

export const ADD_WATCH_LOAD = "ADD_WATCH_LOAD";
export const ADD_WATCH_LOAD_SUCCESS = "ADD_WATCH_LOAD_SUCCESS";
export const REMOVE_WATCH_LOAD = "REMOVE_WATCH_LOAD";
export const REMOVE_WATCH_LOAD_SUCCESS = "REMOVE_WATCH_LOAD_SUCCESS";
export const WATCHED_LOAD_FILTER = "WATCHED_LOAD_FILTER";
export const SUBMIT_FEEDBACK = "SUBMIT_FEEDBACK";
export const GET_SUBMIT_FEEDBACK = "GET_SUBMIT_FEEDBACK";
export const END_USER_TITLE = "End User Licensing Agreement";
export const FREQUENTLY_ASKED_QUESTIONS_TITLE = "Frequently Asked Questions";
export const ADD_DRIVER_DISPATCHER_TITLE = "Add Driver/Dispatcher";
export const MENU_TITLE = "Menu";
export const SEARCH_TITLE = "Search";
export const LOADS_TITLE = "Loads";
export const GET_RECOMMEND_LIST_TEXT =
  "Post your truck or lane to get the most relevant recommended results.";
export const MANAGE_CAPACITY_TEXT = "Manage Capacity";

export enum CALL_US_NUMBER {
  OTM = "<a href='tel:8333918735'>833-391-8735</a>",
  MG = "<a href='tel:8554764786'>855-476-4786</a>",
  DEFAULT = "<a href='tel:83339187352'>833-391-8735-2</a>"
}
export const defaultCountryCode = "+1";

export enum CarrierActionTypes {
  ASSIGN_DRIVER_TO_SHIPMENT = "ASSIGN_DRIVER_TO_SHIPMENT",
  UN_ASSIGN_DRIVER_TO_SHIPMENT = "UN_ASSIGN_DRIVER_TO_SHIPMENT",
  ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE = "ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE",
  UN_ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE = "UN_ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE",
  CLEAR_ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE = "CLEAR_ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE",
  SHOW_ASSIGN_DRIVER_TO_SHIPMENT_DIALOG = "SHOW_ASSIGN_DRIVER_TO_SHIPMENT_DIALOG",
  HIDE_ASSIGN_DRIVER_TO_SHIPMENT_DIALOG = "HIDE_ASSIGN_DRIVER_TO_SHIPMENT_DIALOG",
  CONFIRM_START_INFORMATION = "CONFIRM_START_INFORMATION",
  CONFIRM_START_INFORMATION_SUCCESS = "CONFIRM_START_INFORMATION_SUCCESS",
  CONFIRM_START_INFORMATION_STATUS_MESSAGE = "CONFIRM_START_INFORMATION_STATUS_MESSAGE",
  CLEAR_CONFIRM_START_INFORMATION_STATUS_MESSAGE = "CLEAR_CONFIRM_START_INFORMATION_STATUS_MESSAGE",
  SHIPMENT_FOR_STARTTRIP = "SHIPMENT_FOR_STARTTRIP",
  SHIPMENT_FOR_STARTTRIP_TIMESTAMP = "SHIPMENT_FOR_STARTTRIP_TIMESTAMP",
  UPDATE_STOP_INFORMATION = "UPDATE_STOP_INFORMATION",
  UPDATE_STOP_INFORMATION_RESPONSE = "UPDATE_STOP_INFORMATION_RESPONSE",
  START_TRIP = "START_TRIP",
  START_TRIP_INFORMATION_RESPONSE = "START_TRIP_INFORMATION_RESPONSE",
  COMPLETE_TRIP_API_REQUEST = "COMPLETE_TRIP_API_REQUEST",
  COMPLETE_TRIP_API_RESPONSE = "COMPLETE_TRIP_API_RESPONSE",
  SHOW_WARNING_DIALOG = "SHOW_WARNING_DIALOG",
  CLEAR_WARNING_DIALOG = "CLEAR_WARNING_DIALOG",
  CLEAR_UPDATE_STOP_INFORMATION_RESPONSE = "CLEAR_UPDATE_STOP_INFORMATION_RESPONSE",
  GET_PREDECESSOR_SHIPMENT = "GET_PREDECESSOR_SHIPMENT",
  GET_PREDECESSOR_SHIPMENT_RESPONSE = "GET_PREDECESSOR_SHIPMENT_RESPONSE",
  SUCCESSOR_SHIPMENT = "SUCCESSOR_SHIPMENT",
  SUCCESSOR_SHIPMENT_RESPONSE = "SUCCESSOR_SHIPMENT_RESPONSE",
  CLEAR_SUCCESSOR_SHIPMENT_RESPONSE = "CLEAR_SUCCESSOR_SHIPMENT_RESPONSE",
  CARRIER_INTENT_MESSAGE = "CARRIER_INTENT_MESSAGE",
  CARRIER_INTENT_MESSAGE_RESPONSE = "CARRIER_INTENT_MESSAGE_RESPONSE",
  UPDATE_GPS_STATUS = "UPDATE_GPS_STATUS"
}
export const SORTING_PICKUPDATE = "Pick-up date";

export const REGISTER_DEVICE_ACTION = "REGISTER DEVICE ACTION";
export const FETCH_DRIVER_ASSIGNED_LOADS_FROM_PUSH =
  "FETCH_DRIVER_ASSIGNED_LOADS_FROM_PUSH";
export const REGISTER_DEVICE_RESPONSE_ACTION =
  "REGISTER_DEVICE_RESPONSE_ACTION";
export const REGISTER_MOBILE_NUMBER_ALREADY_EXIST_MESSAGE = "The mobile number you're trying to add is already exist. Please register with different mobile number."
export enum GPS_TRACKING_ERROR_MESSAGE {
  TITLE = "Error Message",
  ERROR_MESSAGE_1 = "You have an active trip, Shipment #",
  ERROR_MESSAGE_2 = ". Please complete that trip, to start tracking a new shipment."
}

export enum ERROR_POPUP {
  TITLE = "Error Message"
}

export const FUNCTIONALITY_COMING_SOON = "Functionality coming soon";
export const PULL_TO_REFRESH_LOADING = "PULL_TO_REFRESH_LOADING";
//exporting keys based on Environment.
export const KEYS = Environment.ENVIROMENT_KEYS();
export const recommendedErrorText =
  "We don't have any recommendations right now. Please come back later.";
export const watchedEmptyText = "You haven't Watched any loads yet";
export const watchedErrorText =
  "Your shipment details could have been updated from other sources. Please check and try again.";
export const recommendedErrorButton = "Search for loads";
export const addCapacityErrorButton = "Add capacity";
export const noMyLoadsErrorButton = "Reset Search";
export const searchResultsErrorText =
  "We don't have any result right now. Please refine your search.";
export const searchResultsErrorButton = "Return to search";
export const matchedLoadAccessText = "feature not available for a guest role";
export const searchLoadsButton = "Search for loads";

export const SHIPMENT_LOADS = "SHIPMENT_LOADS";
export const SHIPMENT_LOADS_MANAGE_USER = "SHIPMENT_LOADS_MANAGE_USER";
export const ACCEPT_DECLINE_LOADS = "ACCEPT_DECLINE_LOADS";
export const LOAD_INTRANSIT_DATA = "LOAD_INTRANSIT_DATA";

export const CHECK_NETWORK_MESSAGE = "Please check your network connection.";
export const MANAGE_FINANCE_URL = "https://secure.triumphpay.com/";

export const SHOW_ALERT_MESSAGE = "SHOW_ALERT_MESSAGE";
export const HIDE_ALERT_MESSAGE = "HIDE_ALERT_MESSAGE";
export const NO_NETWORK = "No network connection";

export const GET_MORE_TAB_CONTENT = "GET_MORE_TAB_CONTENT";
export const MORE_TAB_CONTENT_RESPONSE = "MORE_TAB_CONTENT_RESPONSE";
export const HOME_WEB_CONTENT_RESPONSE = "HOME_WEB_CONTENT_RESPONSE";
export const MORE_TAB_CONTENT_RESPONSE_DUMMY =
  "MORE_TAB_CONTENT_RESPONSE_DUMMY";

export const PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE =
  "Please check your network connectivity and try again.";

// Splash Screen properties
export const splashShowDuration = 3500;
export const splashImage = "./assets/images/splash.gif";

//----------GPS plugin custom properties------------
export const DB_GPS_ACTIVATED_SHIPMENT = "DB_GPS_ACTIVATED_SHIPMENT"; // DB name for GPS activated shipment data storage
export const distanceFilter = 800; //Approximately 800 meters
export const STRING_STOP_TRACKING_TRIP = "Stop Tracking Trip #";
export const GEO_ARRIVAL_RADIUS = 400; // Approximately .25 miles

// Interval time in milliseconds for stationary state identification
export const STATIONARY_IDENTIFIER_INTERVAL = 120000; //2 min, time in milliseconds

export const STATIONARY_IDENTIFIER_MAX_DISTANCE = 200; // 200 meters                            // 0.00621371 miles or 10 meter

export enum MESSAGE_TYPE {
  GEO_START_TRIP_LOCATION = "Geo-Start-Trip-Location", // Workflow: (When trip start) Message Type will send to code system without any convertion from BE
  GEO_POSITION = "Geo-Position", // Geo: (GPS Tracking normal pings) Message Type will send to code system without any convertion from BE
  // Geofence: (Pre-Arrival Fence) converted by BE based on REST API request "action", ie: "action": "ENTER" <Geo-Fence-Pre-Arrival>, "action": "EXIT" <Geo-Stop-Depart>
  GEOFENCE_PRE_ARRIVAL = "Geo-Fence-Pre-Arrival-",
  // Geofence: (Arrival Fence) converted by BE based on REST API request "action", ie: "action": "ENTER" <Geo-Fence-Entry>, "action": "EXIT" <Geo-Fence-Exit>
  GEOFENCE_ARRIVAL = "Geo-Fence-",
  GEO_STOP_ARRIVAL = "Geo-Stop-Arrival", // Workflow: (stationary state) Message Type will send to code system without any convertion from BE
  GEO_TPOSITION = "Geo-TPosition"
}

export enum GEOFENCE_IDENTIFIER {
  PRE_ARRIVAL = "PRE_ARRIVAL",
  ARRIVAL = "ARRIVAL"
}

export enum GEOFENCE_ACTION {
  ENTER = "ENTER",
  EXIT = "EXIT"
}

export enum SOUND_SRC {
  START_TRIP = "./assets/sound/location-services-on.mp3",
  STOP_TRIP = "./assets/sound/location-services-off.mp3",
  GEOFENCE_PRE_ARRIVAL_ENTRY = "./assets/sound/geofence-enter.mp3",
  GEOFENCE_PRE_ARRIVAL_EXIT = "./assets/sound/geofence-exit.mp3",
  GEOFENCE_ARRIVAL_ENTRY = "./assets/sound/tslocationmanager_beep_trip_dry.mp3",
  GEOFENCE_ARRIVAL_EXIT = "./assets/sound/tslocationmanager_beep_trip_up_dry.mp3"
}

export const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

export const ISSUE_WITH_ASSIGNED_LOAD =
  "There seems to be some issue with the assigned load. Kindly try after some time.";

export const UPDATE_STOP_CTA_TEXT = "Update Stop information";
export const STOP_OFF_TEXT = "Stop off ";
export const COMPLETE_TRIP_CTA_TEXT = "Complete Trip";
export const CALL_US_TEXT = "Call us";
export const CONTACT_US_TEXT = "Contact Us";
export const CHAT_TEXT = "Chat with us";
export const INTRANSIT_TEXT = "INTRANSIT";
export const DELIVERED = "MyLoad/DeliveredNeedsPPWK";
export const CONFRIM_START_CTA_TEXT = "Confirm start information";
export const START_LOCATION_LABEL_TEXT = "Start Location";
export const ACTUAL_START_LABEL_TEXT = "Actual Start";
export const ASSIGN_DRIVER_CTA_TEXT = "Assign Driver";
export const UN_ASSIGN_DRIVER_CTA_TEXT = "Un-Assign Driver";
export const VIEW_LOAD_CTA_TEXT = "View Load";
export const BOOK_LOAD_CTA_TEXT = "Book Now";
export const GET_QUALIFIED_CTA_TEXT = "Get Qualified";
export const CONTACT_FOR_PRICE_CTA_TEXT = "Contact to Book";
export const BOOKLOAD_ACCEPT_CTA_TEXT = "Accept";
export const BOOKLOAD_DECLINE_CTA_TEXT = "Decline";
export const VIEW_RATE_DETAILS = "View Rate details";
export const RATE_DETAILS = "Rate Details";
export const CHARGE_DESCRIPTION = "Charge Description";
export const RATE_QUALIFIER = "Rate/ Qualifier";
export const BOOLOAD_QTY = "Qty";
export const BOOKLOAD_TOTAL = "Total";
export const BOOK_LOAD_MODAL_ACCEPT =
  "By accepting you agree to the terms & conditions listed for this load and upon a successful buy, the load will be assigned to you.";
export const BOOKLOAD_THANK_YOU_MESSAGE =
  "Thank you for booking #{{LOAD_ID}} . Tender will be sent to your email momentarily. Click OK to view the execution details and assign your driver.";
export const BOOKLOAD_THANK_YOU_ERROR_MESSAGE =
  "Your load assignment is taking more time than expected. Please check back after 15 minutes under My Loads - Carrier Assigned.";
export const BOOK_LOAD_THANK_YOU_REJECTION_MESSAGE =
  "The request to buy was unsuccessful. Refresh and try again.";
export const BOOKLOAD_THANKYOU_HEADER = "Thank You";
export const BOOKLOAD_REQUEST_REJECTED_HEADER = "Error";
export const BOOK_LOAD_MODAL_ACCEPT_DESKTOP_TERMS =
  "A shipment tender document will be sent to you once assigned within the Schneider Transportation Management System. The carrier must follow this shipment tender documentation, any changes to the shipment will cause an updated tender which would include updated payment information. This transaction is subject to and governed by the written agreement between you and Schneider Transportation Management, a division of Schneider National Carriers, Inc. and the terms of this site.";
export enum MODULES {
  CARRIER_TENDERED_MODULE = "MyLoad/CarrierTendered",
  CARRIER_ASSIGNED_MODULE = "MyLoad/CarrierAssigned",
  DRIVER_ASSIGNED_MODULE = "MyLoad/DriverAssigned",
  INTRANSIT_MODULE = "MyLoad/InTransit",
  RECENTLY_DELIVERED_MODULE = "MyLoad/DeliveredNeedsPPWK",
  DELIVERED_WITH_PPWK_MODULE = "MyLoad/DeliveredWithPPWK",
  SEARCH_RESULTS = "search/results",
  STOF = "Stof/results",
  MANAGE_CAPACITY_SEE_RESULTS = "manage-capacity/see-results"
}
export const DELIVERED_WITH_PPWK_MODULE ="DELIVERED_WITH_PPWK_MODULE"
export enum HOMEMODULES {
  RECOMMENDED_MODULE = "home/recommended",
  WATCHED_MODULE = "home/watched"
}
export const MANAGE_CAPACITY_ADD_PATH = "/app/manage/ManageMyCapacity/Add";
export const REFERENCE = "References";
export const REFERENCE_TYPE_TEXT = "Reference Type";
export const REFERENCE_VALUE_TEXT = "Reference Value";
export const SR_NO_TEXT = "Sr no";
export const REFERENCE_DAILOAG_HEADING = "References";

export const START_TRIP_MESSAGE_FOR_PENDING_LOADS =
  "The Driver assignment for the load is not confirmed yet. Kindly refresh the page or try after some time.";
export const START_TRIP_TEXT = "Start Trip";

export enum EXECUTIONSTATUS {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  STARTED = "STARTED",
  IN_TRANSIT = "IN_TRANSIT",
  DELIVERED = "DELIVERED",
  COMPLETED = "COMPLETED"
}
export const STOP_TRACKING_TEXT = "Stop Tracking";

/**
 * Manage User Constants
 */

export const USER_EXIST_TITLE = "Send Request";
export const USER_EXIST_MESSAGE =
  "{{EMAIL}} already exists.  Do you want to send a request to {{NAME}} to join your carrier account?";
export const USER_BACK_TITLE = "Are you sure you want to navigate back?";
export const USER_BACK_MESSAGE = "You have not saved the new user information.";
export const EMAIL_ERROR = "Please enter valid email address";
export const USER_FORM_ERRORS: any = {
  firstName: "Please enter first name",
  lastName: "Please enter last name",
  mobileNumber: "Please enter a valid phone number",
  tractorNumber: "Tractor Number is required",
  emailAddress: "Please enter valid email address"
};
export const TRACTOR_NUMBER_ERROR = "Please enter valid tractor number";
export const MANAGE_USER_REQUEST = "MANAGE_USER_REQUEST";
export const MANAGE_USER_SUCCESS_MESSAGE =
  "User details has been added successfully";
export const MANAGE_USER_UPDATE_SUCCESS =
  "User details has been updated successfully";
export const MANAGE_USER_REMOVE_SUCCESS_TEXT =
  "User has been delinked successfully";
export const MANAGE_USER_REMOVE_FAILURE_TEXT =
  "User could not be delinked successfully. Please try again."
export const MANAGE_USER_TRANSFER_EXIST =
  "User already exist in current carrier";
export const MANAGE_USER_CONFIRM_TRANSFER_TITLE = "New carrier request";
export const MANAGE_USER_CONFIRM_TRANSFER_MESSAGE =
  '{{COMPANY}} wants to add you as a user. Tap on "Agree" to join.';
export const MANAGE_USER_TRANSFER_MESSAGE = "Request sent to {{NAME}}";
export const MANAGE_USER_TRANSFER_REQUEST = "MANAGE_USER_TRANSFER_REQUEST";
export const MANAGE_USER_TRANSFER_REQUEST_RESET =
  "MANAGE_USER_TRANSFER_REQUEST_RESET";
export const MANAGE_USER_TRANSFER_COFIRM_REQUEST =
  "MANAGE_USER_TRANSFER_COFIRM_REQUEST";
export const MANAGE_USER_TRANSFER_COFIRM = "MANAGE_USER_TRANSFER_COFIRM";
export const GET_MANAGE_USERS_LIST = "GET_MANAGE_USERS_LIST";
export const MANAGE_USERS_LIST_SUCCESS = "MANAGE_USERS_LIST_SUCCESS";
export const MANAGE_USER_SELECTED = "MANAGE_USER_SELECTED";
export const MANAGE_USER_FILTER = "MANAGE_USER_FILTER";
export const MANAGE_USER_TRANSFER = "MANAGE_USER_TRANSFER";
export const MANAGE_USER_VALIDATE = "MANAGE_USER_VALIDATE";
export const MANAGE_USER_VALIDATE_RESET = "MANAGE_USER_VALIDATE_RESET";
export const MANAGE_USER_VALIDATE_STATUS = "MANAGE_USER_VALIDATE_STATUS";
export const MANAGE_USER_ADD = "MANAGE_USER_ADD";
export const MANAGE_USER_ADD_SUCCESS = "MANAGE_USER_ADD_SUCCESS";
export const MANAGE_USER_EDIT = "MANAGE_USER_EDIT";
export const MANAGE_USER_EDIT_SUCCESS = "MANAGE_USER_EDIT_SUCCESS";
export const MANAGE_USER_REMOVE = "MANAGE_USER_REMOVE";
export const MANAGE_USER_REMOVE_SUCCESS = "MANAGE_USER_REMOVE_SUCCESS";
export const MANAGE_USER_LOADED_RESET = "MANAGE_USER_LOADED_RESET";
export const SUBMIT_INVOICE_MESSAGE= "If you have any concerns with this being the proper  amount that will be invoiced,then work with Schneider before submitting any invoices to avoid payment  delays.";
export const MANAGE_USERS_TITLE = "List of users";

export const ROLES: any = {
  carrierGuest: "Guest",
  carrierDispatcher: "Dispatcher",
  carrierDriver: "Driver",
  carrierAdmin: "Admin",
  carrierBeta1: "Beta",
  carrierLeasedOwnerOpr: "Leased on Owner Operator"
};

export const USER_ROLES: any = {
  carrierGuest: "carrierGuest",
  carrierDispatcher: "carrierDispatcher",
  carrierDriver: "carrierDriver",
  carrierAdmin: "carrierAdmin",
  carrierLeasedOwnerOpr: "carrierLeasedOwnerOpr",
  carrierBeta1: "carrierBeta1"
};
export const LO3_ROLE_NAME =  "Owner Operator";
export enum CAPACITYTYPEPOPUP {
  ALERT_MESSAGE = "Do you want to change default capacity type?",
  Ok_TEXT = "OK",
  Cancel_TEXT = "Cancel"
}
export const PREFERENCE_STATUS_UPDATE_FAIL = "Please select at least one option for status updates";
export const BUYLOAD_DATA_REQUEST = "BUYLOAD_DATA_REQUEST";
export const BUYLOAD_DATA_SUCCESS = "BUYLOAD_DATA_SUCCESS";

export const BUYLOAD_RESPONSE_REJECTED =
  "Invalid Request, Please Check your Inputs.";
export const BUYLOAD_REJECTED_RESPONSE = `This load is currently on hold. Please check back in a few minutes or call Schneider at 855-476-4786., 
  Another carrier is interested in this load.`;
export const BOOKLOAD_STATUS_OK = "OK";
export const BOOKLOAD_STATUS_REJECTED = "REJECTED";
export const BOOKLOAD_MESSAGE_OK = "Assignment Successful.";
export const BOOKLOAD_CANCELLED = "CANCELLED";
export const BOOKLOAD_ONHOLD = "ON_HOLD";
export const BOOKLOAD_TIMEOUT = "TIMEOUT";
export const BUYLOAD_REMOVE_STATUS = "BUYLOAD_REMOVE_STATUS";
export const ALL_FIELDS_REQUIRED_TEXT = "*All fields are required";
export const BOOKLOAD_NOT_AVAIABLE_RESPONSE =
  "This load has been Cancelled Please search for another Load";
export const BOOKLOAD_NOT_AVAILABLE = "NOT AVAILABLE";
export const BOOKLOAD_INPROGRESS = "IN_PROGRESS";
export const BOOKLOAD_INPROGRESS_RESPONSE =
  "Transaction is in progress Try again Later";
export const FEEDBACK_RECOMMEND =
  "How likely would you recommended Schneider FreightPower App?";
export const FEEDBACK_HELP =
  "Feedback about your experience is important and will help us continue to improve.";
export const NOT_LIKELY = "Not at all likely";
export const FEEDBACK_MESSAGE =
  "We value your feedback and strive to improve your FreightPower experience.";
export const FEEDBACK_HEADER = "Thank you for your feedback!";
export const FEEDBACK_COMMENTS = "Enter your comments";
export const VERY_LIKELY = "Very likely";
export const FEEDBACK_SUBHEAD = "Feedback";
export const BROWSER_DATA = [
  { name: "Microsoft Edge", value: "Edg/" },
  { name: "Edge", value: "Edge/" },
  { name: "Firefox", value: "Firefox/" },
  { name: "Chrome", value: "Chrome/" },
  { name: "Safari", value: "Safari/" },
  { name: "Opera", value: "Opera/" }
];
export const SUBMIT = "Submit";
export const SAVE = "Save";
export const IMPROVING_SERVICE = "How can we improve our app or service?";
export const GOOD_RATING = "Awesome !";
export const APPSTORE_REVIEW = "We would love an App store review.";
export const MORE_FEEDBACK =
  "Awesome! We would love to have your review on our application.";
export const isGetshipmentError = "isGetshipmentError";
// LoadDetailsPage
export enum BUTTON {
  START_TRIP = "Start Trip",
  STOP_TRACKING = "Stop Tracking"
}

export const STAR: any = {
  STAR_TRUE: "./assets/icon/star-color.svg",
  STAR_FALSE: "./assets/icon/star.svg"
};

export const ORIGIN_FROM_DATE = "origin_from_date";
export const TOTAL_DISTANCE = "totalDistance";
export const ORIGIN_DEADHEAD = "origin_deadhead";
export const DESTINATION_DEADHEAD = "destination_deadhead";
export const PRICE = "Price";
export const DISTANCE = "Distance";
export const RATE = "rate";
export const TOTAL_CHARGE = "totalCharge";
export const LOAD_STOP = "loadStop";
export const APPOINTMENT_FROM = "appointmentFrom";
export const DEADHEAD = "deadHead";

export const ASC_DIRECTION = "asc";
export const DESC_DIRECTION = "desc";

export const sortByOptions: Array<ISortOption> = [
  { value: ORIGIN_FROM_DATE, name: SORTING_PICKUPDATE },
  { value: TOTAL_DISTANCE, name: "Distance" }
];

export const sortByOptionsObject: Array<ISortOption> = [
  { value: ORIGIN_FROM_DATE, name: SORTING_PICKUPDATE },
  { value: TOTAL_DISTANCE, name: "Distance" }
];

export const recommendedSortByOptions: Array<ISortOption> = [
  { value: ORIGIN_FROM_DATE, name: SORTING_PICKUPDATE },
  { value: TOTAL_DISTANCE, name: "Distance" },
  { value: PRICE, name: "Price" }
];

export const CapacitySortByOptions: Array<ISortOption> = [
  { value: ORIGIN_FROM_DATE, name: "Pick-up date" },
  { value: TOTAL_DISTANCE, name: "Distance" },
  { value: PRICE, name: "Price" }
];

export function getSortValues(props: any) {
  return [
    ...CapacitySortByOptions,
    ...(props.origin !== Anywhere
      ? [{ value: "origin_deadhead", name: "Origin deadhead" }]
      : []),
    ...(props.destination !== Anywhere
      ? [{ value: "destination_deadhead", name: "Destination deadhead" }]
      : [])
  ];
}

export const DELINK_ACCOUNT_TITLE = "Delink User account";

export const DELINK_ACCOUNT_TITLE_DESKTOP = "Delink account";
export const DELINK_ACCOUNT_MESSAGE =
  '<span class="sub-heading">Are you sure you want to delink the user account?</span> <br />This process can\'t be undone.';
export const DELINK_ACCOUNT_MESSAGE_DESKTOP =
  "Are you sure? <br/>Do you really want to delink your account? <br/><br/>This process cannot be undone.";

export const BUYLOAD_DATA_OK = "BUYLOAD_DATA_OK";
export const BUYLOAD_SHIPMENT_REQUEST = "BUYLOAD_SHIPMENT_REQUEST";
export const BUYLOAD_SHIPMENT_SUCCESS = "BUYLOAD_SHIPMENT_SUCCESS";
export const REMOVE_SEARCH_RESULTS = "REMOVE_SEARCH_RESULTS";

export const NO_TRUCKS_MESSAGE =
  "We don't have any trucks/lanes right now. <br /> Please click on <b>Add</b> to add new capacity.";
export const OOPS_MESSAGE =
  "There was an error in processing your request. Please try again later.";

export const ADD_CAPACITY_SUCCESS = "Your details has been saved successfully";
export const EDIT_CAPACITY_SUCCESS =
  "Your details has been updated successfully";
export const GET_MANAGE_CAPACITY_LIST = "GET_MANAGE_CAPACITY_LIST";
export const MANAGE_CAPACITY_LIST_SUCCESS = "MANAGE_CAPACITY_LIST_SUCCESS";
export const MANAGE_CAPACITY_SELECTED = "MANAGE_CAPACITY_SELECTED";
export const MANAGE_CAPACITY_ADD = "MANAGE_CAPACITY_ADD";
export const MANAGE_CAPACITY_ADD_SUCCESS = "MANAGE_CAPACITY_ADD_SUCCESS";
export const MANAGE_CAPACITY_EDIT = "MANAGE_CAPACITY_EDIT";
export const MANAGE_CAPACITY_EDIT_SUCCESS = "MANAGE_CAPACITY_EDIT_SUCCESS";
export const MANAGE_CAPACITY_REMOVE = "MANAGE_CAPACITY_REMOVE";
export const MANAGE_CAPACITY_REMOVE_SUCCESS = "MANAGE_CAPACITY_REMOVE_SUCCESS";
export const MANAGE_CAPACITY_FILTER = "MANAGE_CAPACITY_FILTER";

export const GET_MANAGE_CAPACITY_LIST_WITH_COUNT =
  "GET_MANAGE_CAPACITY_LIST_WITH_COUNT";
export const GET_CAPACITY_LOADS = "GET_CAPACITY_LOADS";
export const CAPACITY_LOADS_PAGESIZE = 25;
export const GET_CAPACITY_LOADS_SUCCESS = "GET_CAPACITY_LOADS_SUCCESS";

export const Days = [
  {
    label: "MON",
    value: "MONDAY"
  },
  {
    label: "TUE",
    value: "TUESDAY"
  },
  {
    label: "WED",
    value: "WEDNESDAY"
  },
  {
    label: "THU",
    value: "THURSDAY"
  },
  {
    label: "FRI",
    value: "FRIDAY"
  },
  {
    label: "SAT",
    value: "SATURDAY"
  },
  {
    label: "SUN",
    value: "SUNDAY"
  }
];

export const configParamsConstant = {
  paginationSize: 10,

  gpsTrackingRadiusInMiles: 5,

  gpsTrackingIntervalInMinutes: 15,

  geoFencePreArrivalRadiusInMiles: 1,

  geoFenceEntryRadiusInMiles: 1,

  roleConfigurations: {
    "manage.ManageUsers": {
      "manageUsers": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": false,
        "carrierAdmin": true,
        "carrierLeasedOwnerOpr": false
      }
    },
    "myLoad.InTransit": {
      "inTransit": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "home.Recommended": {
      "recommended": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "search.FavoriteSearch": {
      "favoriteSearch": {
        "carrierGuest": true,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "myLoad.DriverLoads": {
      "driverLoads": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": false,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "myLoad.RecentlyDeliveredLoads": {
      "recentlyDeliveredLoads": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "manage.CarrierProfile": {
      "carrierProfile": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "more.MoreContent": {
      "moreContent": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "manage.ManageMyCapacity": {
      "manageMyCapacity": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": false
      }
    },
    "myLoad.ManageFinancial": {
      "manageFinancial": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false
      }
    },
    "search.RecentSearch": {
      "recentSearch": {
        "carrierGuest": true,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "manage.ManageLanePosting": {
      "manageLanePosting": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": false
      }
    },
    "myLoad.CarrierTendered": {
      "carrierTendered": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": false
      }
    },
    "myLoad.CarrierAssigned": {
      "carrierAssigned": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": false
      }
    },
    "manage.MyProfile": {
      "myProfile": {
        "carrierGuest": true,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "more.MoreMenu": {
      "moreMenu": {
        "carrierGuest": true,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "myLoad.DriverAssigned": {
      "driverAssigned": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "home.Watched": {
      "watched": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "myLoad.Filter": {
      "filter": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "myLoad.AddUser": {
      "addUser": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": false
      }
    },
    "myLoad.BetaTools": {
      "betaTools": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": false,
        "carrierAdmin": false,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": false
      }
    },
    "myLoad.RateDetails": {
      "rateDetails": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": false
      }
    },
    "myLoad.DocumentList": {
      "documentList": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "search.NewSearch": {
      "newSearch": {
        "carrierGuest": true,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "more.InTransit": {
      "inTransit": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "myLoad.ReloadButton": {
      "reloadButton": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierLeasedOwnerOpr": true
      }
    },
    "manage.Preferences": {
      "preferences": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "sidebar.HomeTab": {
      "homeTab": {
        "carrierGuest": true,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "sidebar.SearchTab": {
      "searchTab": {
        "carrierGuest": true,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "sidebar.MyLoadTab": {
      "myLoadTab": {
        "carrierGuest": false,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "sidebar.MyDriverTab": {
      "myDriverTab": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": false,
        "carrierAdmin": true,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": false
      }
    },
    "sidebar.ManageCapacityTab": {
      "manageCapacityTab": {
        "carrierGuest": false,
        "carrierDriver": false,
        "carrierDispatcher": true,
        "carrierAdmin": false,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": false
      }
    },
    "sidebar.FuelSavingTab": {
      "fuelSavingTab": {
        "carrierGuest": true,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "sidebar.TailerLeaseTab": {
      "tailerLeaseTab": {
        "carrierGuest": true,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "sidebar.MoreTab": {
      "moreTab": {
        "carrierGuest": true,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "sidebar.FeedBackTab": {
      "feedBackTab": {
        "carrierGuest": true,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "sidebar.PreferenceTab": {
      "preferenceTab": {
        "carrierGuest": true,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": true
      }
    },
    "sidebar.SupportTab": {
      "supportTab": {
        "carrierGuest": true,
        "carrierDriver": true,
        "carrierDispatcher": true,
        "carrierAdmin": true,
        "carrierBeta1": true,
        "carrierLeasedOwnerOpr": true
      }
    }
  }
};

export enum TAB {
  RECOMMENDED = "recommended",
  WATCHED = "watched",
  NEW = "new",
  RECENT = "recent",
  FAVORITE = "favorite",
  SEARCHED = "searched",
  CARRIER_ASSIGNED = "CarrierAssigned",
  DRIVER_ASSIGNED = "DriverAssigned",
  CARRIER_TENDERED = "CarrierTendered"
}

export const NA = "NA";

export const LOAD_DELIVERED_DATA = "LOAD_DELIVERED_DATA";


export enum LOGIN {
  NO_NETWORK_TITLE = "No Network",
  NO_NETWORK_TEXT = "Please check your network connectivity and try again.",
  Ok_TEXT = "Ok",
  GET_STARTED_TEXT = "Get Started",
  SIGNUP_TEXT = "Start with signing up or sign in"
}

export const OTMASSET = "OTMASSET";

export const PICKUP_DAYS_ERROR = "Kindly select atleast one day";

export const AUTH_SESSION_NAME = "auth-session";

export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_CHECK_MOBILE_NUMBER_EXIST = "REGISTER_CHECK_MOBILE_NUMBER_EXIST";
export const GET_QUALIFIED_TEXT_MESSAGE = "You are not currently active with Schneider. Please contact us at STMCarrier@schneider.com on next steps"
export const GET_QUALIFIED_BUTTON_NAME = "Get Qualified"
export const REGISTER_USER_STATUS_MESSAGE = "REGISTER_USER_STATUS_MESSAGE";
export const SEARCH_LOAD_BY_REFERENCE_ID = "SEARCH_LOAD_BY_REFERENCE_ID";
export const SEARCHED_LOAD_BY_ID = "SEARCHED_LOAD_BY_ID";
export const VALID_REFERENCE_ID =
  "Please enter valid reference ID of 11 characters.";

export const CLEAR_REGISTER_USER_STATUS_MESSAGE =
  "CLEAR_REGISTER_USER_STATUS_MESSAGE";

export const RECOMMENDED_LOADS_REQUEST = "RECOMMENDED_LOADS_REQUEST";

export const RECOMMENDED_LOADS_SUCCESS = "RECOMMENDED_LOADS_SUCESS";
export const TOP_RECOMMENDED_LOADS_SUCCESS = "TOP_RECOMMENDED_LOADS_SUCCESS";

export const SIMILAR_LOADS_SUCCESS = "SIMILAR_LOADS_SUCCESS";
export const AVAILABLE_LOADS_SUCCESS = "AVAILABLE_LOADS_SUCCESS";
export const SIMILAR_LOADS_REQUEST = "SIMILAR_LOADS_REQUEST";
export const AVAILABLE_LOADS_REQUEST = "AVAILABLE_LOADS_REQUEST";
export const REMOVE_RECOMMENDEDRESULTS = "REMOVE_RECOMMENDEDRESULTS";
export const USER_DELETION_REQUEST = "USER_DELETION_REQUEST";
export const TERMS_CONDITION_REQUEST = "TERMS_CONDITION_REQUEST";
export const UPLOAD_DOCUMENT_CONFIG_TYPE = "UPLOAD_DOCUMENT_CONFIG_TYPE";
export const RESEND_INVITE = "RESEND_INVITE";
export const RESEND_INVITE_ASSIGN_DRIVER = "RESEND_INVITE_ASSIGN_DRIVER";
export const CONTACT_US_DETAILS = "CONTACT_US_DETAILS";

export const CLEARBUYLOAD_RESPONSE = "CLEARBUYLOAD_RESPONSE";

export enum ENV {
  UNT = "development",
  UAT = "uat",
  PROD = "production"
}

export enum USER_TYPE {
  PRIMARY_DRIVER = "PRIMARY DRIVER"
}

export const INVITED_USER_CREDENTIALS_DOESNT_MATCH =
  "The invited user and logged in user credential doesn't match. Kindly contact the carrier.";
export const WARNING_TITLE = "Warning";

export const RECOMMENDED_LOADS_LOADDETAILS = "RECOMMENDED_LOADS_LOADDETAILS";
export enum Roles {
  carrierGuest = "carrierGuest",
  carrierAdmin = "carrierAdmin",
  carrierDispatcher = "carrierDispatcher",
  carrierDriver = "carrierDriver",
  carrierLeasedOwnerOpr= "carrierLeasedOwnerOpr"
}

export enum RegisterForm {
  firstName = "firstName",
  lastName = "lastName",
  mobileNumber = "mobileNumber",
  companyName = "companyName",
  corporateZipCode = "corporateZipCode",
  slectedNo = "slectedNo",
  tractorNumber = "tractorNumber",
  parkLocation = "addressDTOs"
}

export enum EXECUTION_ERRORS {
  ARRIVAL_ERROR = "Arrival time can't be more than 60 mins in future",
  DEPARTURE_ERROR = "Departure time can't be more than 60 mins in future",
  DEPARTURE_ARRIVAL_ERROR = "Arrival time can't be greater than the departure time",
  DEPARTURE_ARRIVAL_STOP_ERROR = "Arrival time can't be earlier than the previous stop departure time",
  TRAILER_IN_ERROR = "Trailer-In field is mandatory",
  TRAILER_OUT_ERROR = "Trailer-Out field is mandatory",
  MISSING_ACTIVITY = "Stop activity missing, trailer information can't be updated. Please contact Schneider.",
  NO_MAPPING_ACTIVITY = "Stop activity mapping not found, trailer information can't be updated. Please contact Schneider.",
  VALID_TRAILER_IN = "Please enter valid Trailer-In value",
  VALID_TRAILER_OUT = "Please enter valid Trailer-Out value",
  INVALID_TRAILER_OUT_WARNING = "Previous stop has invalid trailer. Enter valid trailer and update that stop before this stop can be updated"
}

export const SHOW_API_RESPONSE_ERROR = "SHOW_API_RESPONSE_ERROR";

export const SHOW_MEMBER_API_ERROR = "SHOW_MEMBER_API_ERROR";

export const MEMBER_API_ERROR_MESSAGE =
  "System error occurred. Please try after sometime.";

export const CLEAR_API_RESPONSE_ERROR = "CLEAR_API_RESPONSE_ERROR";
export const SET_STOF_KEY = "SET_STOF_KEY";
export const SESSION_INFO = "SESSION_INFO";
export const TAB_NAME = "TAB_NAME";
export const WATCHED_LOAD_REMOVE = "Watched load removed";
export const WATCHED_LOAD_ADDED = "Watched load added";

export const SORTING_ORDER_ASC = "asc";
export const SORTING_ORDER_DESC = "desc";
export const PICKUPDATE_DROPDOWN = "Pickupdate";
export const RECOMMENDED_TAB = "recommended";
export const WATCHED_TAB = "watched";
export const RECOMMENDED_TAB_HEADING = "Recommended Loads";
export const WATCHED_TAB_HEADING = "Watched Loads";

export const UNKNOWN = "UNKNOWN";
export const RECOMMENDATION_COUNT = "Recommendation";
export const RECOMMENDATION_COUNTS = "Recommendations";
export const WATCHED_COUNT = "Watched Load";
export const WATCHED_COUNTS = "Watched Loads";
export const RECOMMENDED_LOAD_FILTER = "RECOMMENDED_LOAD_FILTER";
export const BUYLOAD_MODULE = "BUYLOAD_MODULE";

//R2 Configuration
export enum ENABLE_R2_FEATURE {
  CONFIGURATION_TXT = "Configuration",
  ENABLE_R2_FEATURE_TXT = "Enable R2 feature",
  OKAY = "Okay"
}

export const OFFLINE_MODE_STATE = true;
export const CHANGE_PASSWORD_TITLE = "Redirected to external site";
export const CHANGE_PASSWORD_MESSAGE =
  "You will be redirected to the secure site to change your password.";
export enum BUTTONS {
  OK = "Ok",
  CANCEL = "Cancel",
  DELINK = "Delink"
}

export const APPLE_DEVICES = [
  {
    identifier: "iPhone5,1",
    generation: "iPhone 5"
  },
  {
    identifier: "iPhone5,2",
    generation: "iPhone 5"
  },
  {
    identifier: "iPhone5,3",
    generation: "iPhone 5c"
  },
  {
    identifier: "iPhone5,4",
    generation: "iPhone 5c"
  },
  {
    identifier: "iPhone6,1",
    generation: "iPhone 5s"
  },
  {
    identifier: "iPhone6,2",
    generation: "iPhone 5s"
  },
  {
    identifier: "iPhone7,2",
    generation: "iPhone 6"
  },
  {
    identifier: "iPhone7,1",
    generation: "iPhone 6 Plus"
  },
  {
    identifier: "iPhone8,1",
    generation: "iPhone 6s"
  },
  {
    identifier: "iPhone8,2",
    generation: "iPhone 6s Plus"
  },
  {
    identifier: "iPhone12,8",
    generation: "iPhone SE"
  },
  {
    identifier: "iPhone8,4",
    generation: "iPhone SE"
  },
  {
    identifier: "iPhone9,3",
    generation: "iPhone 7"
  },
  {
    identifier: "iPhone9,1",
    generation: "iPhone 7"
  },
  {
    identifier: "iPhone9,4",
    generation: "iPhone 7 Plus"
  },
  {
    identifier: "iPhone9,4",
    generation: "iPhone 7 Plus"
  },
  {
    identifier: "iPhone10,1",
    generation: "iPhone 8"
  },
  {
    identifier: "iPhone10,4",
    generation: "iPhone 8"
  },
  {
    identifier: "iPhone10,2",
    generation: "iPhone 8 Plus"
  },
  {
    identifier: "iPhone10,5",
    generation: "iPhone 8 Plus"
  },
  {
    identifier: "iPhone10,3",
    generation: "iPhone X"
  },
  {
    identifier: "iPhone10,6",
    generation: "iPhone X"
  },
  {
    identifier: "iPhone11,2",
    generation: "iPhone XS"
  },
  {
    identifier: "iPhone11,4",
    generation: "iPhone XS Max"
  },
  {
    identifier: "iPhone11,6",
    generation: "iPhone XS Max"
  },
  {
    identifier: "iPhone11,8",
    generation: "iPhone XR"
  },
  {
    identifier: "iPhone12,1",
    generation: "iPhone 11"
  },
  {
    identifier: "iPhone12,3",
    generation: "iPhone 11 Pro"
  },
  {
    identifier: "iPhone12,5",
    generation: "iPhone 11 Pro Max"
  },
  {
    identifier: "iPad6,7",
    generation: 'iPad Pro (12.9")'
  },
  {
    identifier: "iPad6,8",
    generation: 'iPad Pro (12.9")'
  },
  {
    identifier: "iPad6,3",
    generation: 'iPad Pro (9.7")'
  },
  {
    identifier: "iPad6,4",
    generation: 'iPad Pro (9.7")'
  },
  {
    identifier: "iPad7,1",
    generation: 'iPad Pro (12.9")(2nd generation)'
  },
  {
    identifier: "iPad7,2",
    generation: 'iPad Pro (12.9")(2nd generation)'
  },
  {
    identifier: "iPad7,3",
    generation: "iPad Pro (10.5-inch)"
  },
  {
    identifier: "iPad7,4",
    generation: "iPad Pro (10.5-inch)"
  },
  {
    identifier: "iPad8,1",
    generation: "iPad Pro (11-inch)"
  },
  {
    identifier: "iPad8,2",
    generation: "iPad Pro (11-inch)"
  },
  {
    identifier: "iPad8,3",
    generation: "iPad Pro (11-inch)"
  },
  {
    identifier: "iPad8,4",
    generation: "iPad Pro (11-inch)"
  },
  {
    identifier: "iPad8,5",
    generation: 'iPad Pro (12.9") (3rd generation)'
  },
  {
    identifier: "iPad8,6",
    generation: 'iPad Pro (12.9") (3rd generation)'
  },
  {
    identifier: "iPad8,7",
    generation: 'iPad Pro (12.9") (3rd generation)'
  },
  {
    identifier: "iPad8,8",
    generation: 'iPad Pro (12.9") (3rd generation)'
  },
  {
    identifier: "iPad8,11",
    generation: 'iPad Pro (12.9") (4th generation)'
  },
  {
    identifier: "iPad8,11",
    generation: 'iPad Pro (12.9") (4th generation)'
  },
  {
    identifier: "iPad8,9",
    generation: "iPad Pro (11-inch) (2nd generation)"
  },
  {
    identifier: "iPad8,10",
    generation: "iPad Pro (11-inch) (2nd generation)"
  },
  {
    identifier: "iPad4,1",
    generation: "iPad Air"
  },
  {
    identifier: "iPad4,2",
    generation: "iPad Air"
  },
  {
    identifier: "iPad4,3",
    generation: "iPad Air"
  },
  {
    identifier: "iPad5,3",
    generation: "iPad Air 2"
  },
  {
    identifier: "iPad5,3",
    generation: "iPad Air 2"
  },
  {
    identifier: "iPad11,3",
    generation: "iPad Air (3rd generation)"
  },
  {
    identifier: "iPad11,4",
    generation: "iPad Air (3rd generation)"
  }
];

export const trailersConfiguration: {
  [key: string]: {
    width?: string;
    webWidth?: string;
    showReadOnlyField?: boolean;
    placeholder: string;
    maxlength: any;
    keyBoardType?: any;
    type?: any;
    trailerIn?: any;
    trailerOut?: any;
  };
} = {
  TA: {
    width: "20px",
    webWidth: "35px",
    showReadOnlyField: true,
    placeholder: "######",
    maxlength: 6,
    keyBoardType: "numeric",
    type: "number",
    trailerIn : ["P","D","BorderCrossing","Relay","NFR"],
    trailerOut : ["P","D","BorderCrossing","Relay","NFR"]
  },
  SNLU: {
    width: "40px",
    webWidth: "70px",
    showReadOnlyField: true,
    placeholder: "######",
    maxlength: 6,
    keyBoardType: "numeric",
    type: "number",
    trailerIn : ["P","D","BorderCrossing","Relay","NFR"],
    trailerOut : ["P","D","BorderCrossing","Relay","NFR"]
  },
  SNCZ: {
    width: "40px",
    webWidth: "70px",
    showReadOnlyField: true,
    placeholder: "######",
    maxlength: 6,
    keyBoardType: "numeric",
    type: "number",
    trailerIn : [],
    trailerOut : ["P","D","NFR"]
  },
  OTHER: {
    placeholder: "@#@#@#@#@#@#@#@",
    showReadOnlyField: false,
    maxlength: 15,
    keyBoardType: "text",
    type: "text",
    trailerIn : ["P","D","BorderCrossing","Relay","NFR"],
    trailerOut : ["P","D","BorderCrossing","Relay","NFR"]
  },
  BOBTAIL: {
    placeholder: "",
    showReadOnlyField: false,
    maxlength: 0,
    keyBoardType: "text",
    type: "text",
    trailerIn : ["P","BorderCrossing","Relay","NFR"],
    trailerOut : ["D","BorderCrossing","Relay","NFR"]
  }
};

export const trailerRegConfig = [
  { type: "TA", expression: /^TA[0-9]{6}/ },
  { type: "SNLU", expression: /^SNLU[0-9]{6}/ },
  { type: "SNCZ", expression: /^SNCZ[0-9]{6}/ },
  { type: "BOBTAIL", expression: /BOBTAIL/ }
];

export const BOBTAIL = "BOBTAIL";
export const OTHER = "OTHER";
export const SNCZ = "SNCZ";
export const TRAILER_OUT = "trailerOut";

export const BOOKLOAD_SUCCESS_REDIRECTION = "BOOKLOAD_SUCCESS_REDIRECTION";

export const TIME_ZONE = "America/New_York";
export const SEARCH_PARAMS = "SEARCH_PARAMS";

export const NO_REFERENCE_MSG = "No references for the stop";

export const NO_AUTH_MSG =
  "We are having trouble signing you in. Please try again later.";

export const DELETE_ACCOUNT_CONFIRMATION_TITLE= "Delete account confirmation";
export const DELETE_ACCOUNT= "Delete Account";
export const DELETE_ACCOUNT_MESSAGE= "If you want to permanently delete your account, let us know. Once the deletion process begins, you won't be able to reactivate your account or retrieve any of the content or information you have added.";
export const DELETE_ACCOUNT_MESSAGE_TITLE= "Are you sure you want to permanently delete account?";
export const DELETE_ACCOUNT_CONFIRMATION_MESSAGE= "Are you sure you want to permanently delete account?";

export const USER_DELETION_UNSUCCESSFUL_MSG =
  "We are having trouble to delete. Please try again later.";

export const NO_ACCESS_MSG = "Contact Schneider to get full access";
export const REGISTER_TO_GET_FULL_ACCESS = "Register to get full access.";
export const CALL_NOW = "Call Now";

export const dropDownOptions = ["TA", "SNLU","SNCZ", "BOBTAIL", "OTHER"];

export const TRAILER_PARTTEN = /^(SNLU[0-9]{6}$)|(SNCZ[0-9]{6}$)|(TA[0-9]{6}$)|(BOBTAIL)$/;

export const CARRIER_PROFILE_INFO =
  "Contact Schneider if any of the fields need to be updated";
export const CARRIER_PROFILE_INSURANCE =
  "New insurance certs will show starting at the effective date. If your cert is close to expiry, please send insurance cert to xxxxxx@rmis.com";
export const CARRIER_INFO = "Carrier Info";
export const CARRIER_CONTACT_DETAILS = "Contact Details";
export const CARRIER_INSURENCE = "Carrier Insurance";
export const CARRIER_CERITIFCATION = "Certification";
export const CARRIER_QUALIFICATION_STATUS = "Qualification Status";
export const CARRIER_PROFILE_FOOTER =
  'Contact Schneider at <a href="mailto:stmcarrier@schneider.com" className="email">stmcarrier@schneider.com</a> <span>if any of the fields need to be updated</span>';

export enum LOGOUTPOPUP {
  ALERT_MESSAGE = "Are you sure you want to logout?",
  Logout_TEXT = "Logout",
  Cancel_TEXT = "Cancel",
  REGISTRATION_ALERT_MESSAGE = "Are you sure you want to log out without completing registration?"
}

export const FAVORITE_SEARCH_REMOVED = "Favorite search removed";
export const CAPACITY_REMOVED = "{{CAPACITY}} removed";
export const FAVORITE_ALREADY_EXIST_TITLE = "Record Exist";
export const FAVORITE_ALREADY_EXIST_MESSAGE =
  "This record already exists in your favorites list. Please update your search criteria to save the search as a favorite.";

export const ASSIGN_DRIVER_POPUP_TITLE =
  "Are you sure you want to assign load #{{LOAD_ID}} to {{DRIVER_NAME}}";
export const LOAD_ASSIGN_SUCCESS =
  "Load #{{LOAD_ID}} assigned successfully to {{DRIVER_NAME}}.";
export const LOAD_UN_ASSIGN_SUCCESS =
  "Load #{{LOAD_ID}} unAssigned successfully from {{DRIVER_NAME}}.";
export const LOAD_ASSIGN_FAIL =
  "Driver assignment was unsuccessful. Please try again.";
export const LOAD_UN_ASSIGN_FAIL =
  "Driver unAssignment was unsuccessful. Please try again.";
export const BOOKLOAD_ON_HOLD = "Warning";
export const BOOKLOAD_CANCELLED_MESSAGE = "Error";
export const YES = "Yes";
export const NO = "No";

export const ADD_USER = "Add Driver/Dispatcher";
export const EDIT_USER = "Edit User";
export const EDIT_PROFILE = "Edit Profile";
export const TRACTOR_NUMBER = "tractorNumber";
export const ALL_DRIVER_TEXT = "All Driver";
export const CARRIER_ASSIGNED_TEXT = "Carrier Assigned";
export const SHOW_BUYLOAD_API_ERROR = "SHOW_BUYLOAD_API_ERROR";
export const GET_STOF_LOADS = "GET_STOF_LOADS";

export const SEARCH_BY_LOAD = "Search by Load #";
export const ENTER_INVOICE_ID_HEADER = "Enter Invoice # ";
export const CARRIER_PRO_ID_HEADER = " PRO # (Optional) ";
export const INVOICE_CARRIER_PRO_ID_INPUT = " PRO # ";
export const CARRIER_PRO_LABEL = "Carrier PRO : "
export const BUYLOAD_API_ERROR_MESSAGE =
  "Your load assignment is taking longer than expected. Kindly contact Schneider to verify assignment, if you don't receive tender on email in the next 5 minutes.";

export const US = "US";
export const USA = "USA";

export const CA = "CA";
export const CAN = "CAN";

export const MX = "MX";
export const MEX = "MEX";
export const NO_NEXT_ROUTE = "NO NEXT ROUTE";
export const NEED_NEXT_ROUTE = "NEED NEXT ROUTE";

export const App_permission_message =
  "This app will collect location data during an active trip execution so that we can automatically track the shipments, trigger workflow events on your behalf while the app is in use or backgrounded state. <br/> <br/> You will be prompted with run time permission dialog subsequently as you start using relevant features of the app. We encourage you to provide those permissions to maximize value of the app.";
export const App_permission_title = "Disclosure";

export enum PROFILE_FIELDS {
  FIRST_NAME = "First Name",
  LAST_NAME = "Last Name",
  MOBILE_NUMBER = "Mobile Number",
  EMAIL_ADDRESS = "Email Address",
  EMAIL = "Email",
  PARK_LOCATION = "Park Location (Optional)",
  TRACKTOR_NUMBER = "Tractor No",
  CARRIER_ID = "Carrier ID",
  ROLES = "Role(s)",
  ROLE = "Role",
  VALIDATE_NOW = "Validate now",
  CONTINUE = "Continue"
}

export enum PROFILE_FIELDS_PLACEHOLDER {
  FIRST_NAME = "Type Your First Name",
  LAST_NAME = "Type Your Last Name",
  MOBILE_NUMBER = "Type Your Mobile Number",
  EMAIL_ADDRESS = "Type Your Email Address",
  PARK_LOCATION = "Type Your Park Location Address",
  TRACKTOR_NUMBER = "Type Your Tractor Number",
  CARRIER_ID = "",
  NEW_USER_NUMBER = "Type New User's Mobile #"
}

export enum RoleUpdate_Alert {
  header = "Congratulations!",
  message = "Your access has been updated. Log out and log in to get full access. Choose ignore to continue as Guest.",
  ignore_btn = "Ignore",
  logout_btn = "Logout Now"
}

export enum PAGE_TITLES {
  SEARCH = "Search",
  FEEDBACK = "Feedback",
  PREFERENCES = "Preferences",
  MY_LOADS = "My Loads",
  MANAGE_USERS = "Manage Users",
  MANAGE_CAPACITY_ADD = "Add New Capacity",
  MANAGE_CAPACITY_EDIT = "MANAGE_CAPACITY_EDIT",
  MANAGE_CAPACITY = "Manage Capacity",
  MANAGE_CAPACITY_VIEW = "MANAGE_CAPACITY_VIEW",
  SITENEWS = "Site News",
  MYPROFILE = "My Profile",
  NOTIFICATIONS = "Notifications"
}

export const FEEDBACK = "feedback";
export const PREFERENCES = "preferences";
export const MORE = "more";
export const MY_LOAD = "myLoad";
export const HOME = "home";

export enum PageView {
  LIST = "list",
  MAP = "map"
}
export enum REGISTER_ERROR_MESSAGE {
  mobileNumberError = "Please enter a valid phone number",
  zipcodeEror = "Please enter a valid company corporate ZIP code",
  usDotError = "Please enter a valid company USDOT#",
  mcError = "Please enter a valid company MC#",
  roleError = "Please select a user type",
  firstNameError = "Please enter a valid first name",
  lastNameError = "Please enter a valid last name",
  companyNameError = "Please enter a valid company name",
  tractorNumberError = "Please enter a tractor number"
}

export enum SERVER_ERROR_MESSAGES {
  serverErrorMsg = "Error, please refresh and try again",
  unAuthorizedMsg = "Login expired, Log Out and log back in to try again"
}

export const carrierUsDotNo = "carrierUsDotNo";
export const carrierMcNo = "carrierMcNo";

export enum REGISTER_PLACEHOLDER {
  mobileNumber = "Enter your cell phone number",
  zipcode = "Enter your company corporate ZIP code",
  usDot = "Enter your company USDOT#",
  mc = "Enter your company MC#",
  firstName = "Enter your first name",
  lastName = "Enter your last name",
  companyName = "Enter your company name",
  tractorNumber = "Enter Your Tractor Number"
}

export enum REGISTER_PLACEHOLDER_DESKTOP {
  mobileNumber = "Type your Cell Phone Number",
  zipcode = "Enter your Company Corporate Zip Code",
  usDot = "Enter your Company USDOT",
  mc = "Enter your Company MC#",
  firstName = "Enter your First Name",
  lastName = "Enter your Last Name",
  companyName = "Enter your Company Name",
  tractorNumber = "Enter Your Tractor Number"
}

export enum REGISTER_LABEL {
  role = "User Type (Select all that apply)",
  firstName = "First name",
  lastName = "Last name",
  phoneNumber = "Cell phone number",
  company = "Company name",
  zipcode = "Company corporate ZIP code",
  usdotOrMc = "Company USDOT# or MC#",
  USDOT = "USDOT#",
  MC = "MC#",
  register = "Register Now",
  tractorNumber = "Truck No",
  parkLocation = "Park Location (Optional)",
  createProfile = "Create Profile",
  saveProfile = "Save Profile",
  allFieldsRequired = "*All fields are required"
}
export enum REGISTER_LABEL_DESKTOP {
  role = "User Type (Select all that apply)",
  firstName = "First Name",
  lastName = "Last Name",
  phoneNumber = "Cell Phone Number",
  company = "Company Name",
  zipcode = "Company Corporate Zip Code",
  usdotOrMc = "Company USDOT or MC#",
  USDOT = "USDOT",
  MC = "MC#",
  registerDesktop = "Register",
  createProfile = "Create Profile",
  saveProfile = "Save Profile"
}
export const DEVICE_PLATFORM = "DEVICE_PLATFORM";
export enum ALERT_BUTTON_ROLES {
  ok = "ok",
  cancel = "cancel"
}
export enum ICON_PATH {
  callus = "./assets/icon/Phone.svg",
  complete_trip = "./assets/icon/complete-trip.svg",
  mid_illustration = "./assets/images/Mid illustration.png",
  mid_icon = "./assets/icon/mid-icon.svg",
  search_error = "./assets/icon/SearchError.svg",
  add_capacity = "./assets/images/manage-add-capacity.svg",
  assign_driver = "./assets/icon/add-user-icon.svg",
  start_trip = "./assets/icon/start-trip.svg",
  chat = "./assets/icon/chat.svg",
  defult_map = "./assets/images/default_map.png",
  logo = "./assets/icon/Logo.svg",
  down_arrow = "./assets/icon/grid-down-arrow.svg",
  plus = "./assets/icon/add.svg",
  minus = "./assets/icon/minus-icon.svg",
  origin_pointer = "./assets/icon/origin-pointer.svg",
  stop_pointer = "./assets/icon/stop-pointer.svg",
  destination_pointer = "./assets/icon/dst-pointer.svg",
  start_trip_pointer = "./assets/icon/start-trip-location.svg",
  filter = "./assets/icon/filter.svg",
  driver = "./assets/icon/Assign Driver.svg",
  shipment_map = "./assets/icon/shipment-map-icon.svg",
  pageNotFound = "./assets/icon/pageNotFound.svg",
  nav_home = "./assets/icon/nav-home-icon.svg",
  nav_search = "./assets/icon/bottom_search_icon.svg",
  nav_myLoad = "./assets/icon/My Load.svg",
  nav_manage = "./assets/icon/manag icon.svg",
  nav_more = "./assets/icon/more icon.svg",
  unAssign_driver = "./assets/icon/un-assign-driver.svg",
  references_mobile = "./assets/icon/references.svg",
  check_payment_status = "./assets/icon/check-payment.svg",
  pay_button = "./assets/icon/add_invoice.svg",
  no_route_icon = "assets/icon/no-route-icon.svg",
  no_search_icon = "assets/icon/no-search-icon.svg",
  document_button = "assets/icon/document-icon.svg",
  doc_icon = "assets/icon/doc-icon.svg",
  contact_us_icon = "assets/icon/contact-us-icon.svg",
  assign_driver_icon = "assets/icon/assign-driver-icon.svg",
  unassign_driver_icon = "assets/icon/unassign-driver-icon.svg",
  arrow_right = "assets/icon/arrow-right.svg",
  crop_icon = "assets/icon/crop-icon.svg",
  flash = "assets/icon/flash.svg",
  rotate_left = "assets/icon/rotate-left.svg",
  save_icon = "assets/icon/save-icon.svg",
  white_button = "assets/icon/white-button.svg",
  services = "assets/icon/other-services.svg"
}

export const SET_CAPACITY_TO_SEE_RESULT = "SET_CAPACITY_TO_SEE_RESULT";

export const GET_USER_PREFERENCES = "GET_USER_PREFERENCES";
export const SAVE_USER_PREFERENCES = "SAVE_USER_PREFERENCES";
export const GET_NEW_USERDETAILS ="GET_NEW_USERDETAILS"
export const UPDATE_USER_PREFERENCES = "UPDATE_USER_PREFERENCES";
export const SAVE_USER_PREFERENCES_DOMAIN = "SAVE_USER_PREFERENCES_DOMAIN";
export const SET_DYNAMIC_LINK_PARAMS = "SET_DYNAMIC_LINK_PARAMS";
export const GET_USER_NOTIFICATIONS = "GET_USER_NOTIFICATIONS";
export const UPDATE_STATUS_USER_NOTIFICATION =
  "UPDATE_STATUS_USER_NOTIFICATION";
export const SET_USER_NOTIFICATIONS = "SET_USER_NOTIFICATIONS";
export const UPDATE_NOTIFICATION_BELL_ICON = "UPDATE_NOTIFICATION_BELL_ICON";
export const UPDATE_NEW_TO_UNREAD_NOTIFICATION =
  "UPDATE_NEW_TO_UNREAD_NOTIFICATION";

export enum RecentNavigationTypes {
  MYLOAD = "MYLOAD"
}

export const SET_NAVIGATION = "SET_NAVIGATION";
export const ALL_DRIVERS_TEXT = "All Drivers";
export enum Navigate_Module {
  watched = "/app/home/watched/",
  recommended = "/app/home/recommended/",
  manage_capacity = "/app/manage/ManageMyCapacity",
  search = "/app/search",
  home = "/app/home",
  search_results = "/app/search/results"
}
export enum Navigate_Module_Web {
  watched = "/app/home/watched",
  recommended = "/app/homerecommended",
  watched_load = "/app/homewatched",
  manage_capacity = "/app/manage/ManageMyCapacity",
  search = "/app/search",
  home = "/app/home",
  search_results = "search/results",
  manage_capacity_see_results = "/app/manage-capacity/see-results"
}


export enum OOPS_NO_RECORD_FOUND_MESSAGE {
  OOPS_TITLE = "Error",
  OOPS_MESSAGE = "Requested record not found. <br />Click ok to go back",
  PAGE_NOT_FOUND_MESSAGE1 = "Oops!",
  PAGE_NOT_FOUND_MESSAGE2 = "Page not Found.",
  PAGE_NOT_FOUND_MESSAGE3 = "We couldn't find the page",
  PAGE_NOT_FOUND_MESSAGE4 = "Click ok to go back or click Homepage to go back to Home screen",
  BACK_BTN = "Go Back",
  HOME_BTN = "Home Page"
}

export enum unAssign_driver_alert {
  title = "Un-Assign Driver",
  message = "Are you sure you want to un-assign {name} from {loadId}"
}
export enum FETCH_VALUE {
  SUB = "sub",
  CARRIERID = "carrierId",
  UPN = "upn",
  ROLES = "roles",
  UTM_SOURCE = "custom_source",
  UTM_MEDIUM = "custom_medium",
  UTM_CAMPAIGN = "custom_campaign"
}

export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";

export const API_CALLED = "API_CALLED";

export const SAVE_PREFERENCE_SUCCESS_MESSAGE = "Your Preferences are saved.";

export const SAVE_PREFERENCE_FAILURE_MESSAGE =
  "Your Preferences could not be saved. Please try after some time.";

export const UNASSIGN_DRIVER_POPUP_TITLE =
  "Are you sure you want to unassign #Driver from #LoadId ?";

export const CARRIER_TENDERED_MODULE_WEB = "/app/MyLoad/CarrierTendered";
export const CARRIER_ASSIGNED_MODULE_WEB = "/app/MyLoad/CarrierAssigned";
export const DRIVER_ASSIGNED_MODULE_WEB = "/app/MyLoad/driverAssigned";
export const INTRANSIT_MODULE_WEB = "/app/MyLoad/InTransit";
export const DELIVERED_NEEDS_PPWK_MODULE_WEB = "/app/MyLoad/DeliveredNeedsPPWK";
export const DELIVERED_WITH_PPWK_MODULE_WEB = "/app/MyLoad/DeliveredWithPPWK";
export const TERM_AND_CONDITION_WEB_TEXT_1 = `A shipment tender document will be sent to you once assigned within the Schneider Transportation Management System. 
The carrier must follow this shipment tender documentation, any changes to the shipment will cause an updated 
tender which would include updated payment information.`;
export const ADD_PROFILE_PATH = "/app/userProfile/add";
export enum Tab_Paths {
  CARRIER_ASSIGNED = "app/MyLoad/CarrierAssigned",
  DRIVER_ASSIGNED = "app/MyLoad/driverAssign",
  SHIPMENT_EXECUTION = "app/MyLoad/shipmentUpdateScreen",
  DRIVER_ASSIGNED_LOAD = "app/MyLoad/DriverAssigned"
}
export enum MODULE_PATHS {
  CARRIER_TENDERED = "MyLoad/CarrierTendered",
  CARRIER_ASSIGNED = "MyLoad/CarrierAssigned",
  DRIVER_ASSIGNED = "MyLoad/DriverAssigned",
  INTRANSIT = "MyLoad/InTransit",
  DELIVEREDNEEDSPPWK = "MyLoad/DeliveredNeedsPPWK",
  DELIVEREDWITHPPWK = "MyLoad/DeliveredWithPPWK"
}
export enum MY_LOADS_BUCKET {
  CARRIER_TENDERED = "carrierTendered",
  CARRIER_ASSIGNED = "carrierAssigned",
  DRIVER_ASSIGNED = "driverAssigned",
  INTRANSIT = "inTransit",
  DELIVEREDNEEDSPPWK = "deliveredNeedsPaperWork",
  DELIVEREDWITHPPWK = "deliveredWithPaperWork"
}

export const CLEAR_UPDATE_FAVORITE_LOADS_ID = "CLEAR_UPDATE_FAVORITE_LOADS_ID";

export const SET_RECOMMENDED_API_ERROR = "SET_RECOMMENDED_API_ERROR";

export const recommendedApiError =
  "<p>No recommendations available, please try again later</p>";

export const LIST_FULL_TITLE = "Limit Exceeded";

export const MESSAGE_TEXT = "Favorite search list full";

export const FIVE_SEC = 5000;
export const ONE_HOUR = 3600000;
export const SHIPMENT_UPDATE_SCREEN = "shipmentUpdateScreen";
export const MANAGE_USER_SCREEN = "/app/manage/ManageUser";
export const HOUR_FORMAT = 12;

export enum USER_REGISTRATION_PLACEHOLDER {
  FIRST_NAME = "Type First Name",
  LAST_NAME = "Type Last Name",
  MOBILE_NUMBER = "Type Mobile Number",
  EMAIL_ADDRESS = "Type Email Address",
  PARK_LOCATION = "Type Park Location Address",
  TRACKTOR_NUMBER = "Type Tractor Number",
  CARRIER_ID = "",
  NEW_USER_NUMBER = "Type New User's Mobile #"
}
export const NOT_APPLICABLE = "N/A";

export const LPEFEEDBACK_APP_NAME = "FreightPower Carrier";
export const ZOOM_VALUE_7X = 7;
export const ZOOM_VALUE_17X = 17;
export const LOAD_MAP_PADDING = {
  left: 50,
  right: 50,
  top: 50,
  bottom: 50
};
export const SHIPMENT_MAP_PADDING = {
  left: 100,
  right: 100,
  top: 100,
  bottom: 100
};
export const EXPAND_MAP = "Expand Map";
export const EXPAND_MAP_SRC = "assets/icon/expand.svg";
export const COLLAPSE_MAP = "Collapse Map";
export const COLLAPSE_MAP_SRC = "assets/icon/Collapse.svg";
export const MAP_POINTER = "pointer";
export const ROUTE_COLOR = "#3888EA";
export const LOAD_MARKER = `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45"><defs><style>.a{fill:#f85f14;}.b{fill:#fff;}</style></defs><ellipse class="a" cx="22" cy="22.5" rx="22" ry="22.5"/><ellipse class="b" cx="16" cy="16.5" rx="16" ry="16.5" transform="translate(6 6)"/></svg>`;
export const ORIGIN_MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><defs><style>.a{fill:#f85f14;}</style></defs><circle class="a" cx="6" cy="6" r="6"/></svg>`;
export const DESTINATION_MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="38.764" viewBox="0 0 25 38.764"><defs><style>.a{fill:#ff6418;}.b{fill:#c54100;}</style></defs><g transform="translate(-171 -533)"><path class="a" d="M30.3,2.5A12.492,12.492,0,0,0,17.8,15c0,4.93,6.328,16.576,9.977,22.9,2.36,6.476,3.921,1.941,5.047,0C36.472,31.576,42.8,19.891,42.8,15A12.492,12.492,0,0,0,30.3,2.5Zm0,19.643A7.143,7.143,0,1,1,37.443,15,7.149,7.149,0,0,1,30.3,22.143Z" transform="translate(153.2 530.5)"/><circle class="b" cx="7.395" cy="7.395" r="7.395" transform="translate(176.449 537.985)"/></g></svg>`;
export const STOP_MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><rect width="12" height="12"/></svg>`;
export const NFR_MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><defs><style>.a{fill:#0aa52c;}</style></defs><rect class="a" width="12" height="12"/></svg>`;
export const MYLOAD_TAB_NAME = "execute";
export enum TAB_HEADERS_WEB {
  NEW_SEARCH = "New Search",
  FAVORITE_SEARCH = "Favorite Search",
  RECENT_SEARCH = "Recent Search",
  MATHCED_LOADS = "Matched Loads"
}

export enum SORT_OPTIONS {
  pickUpStartDate = "pickUpStartDate",
  total_distance = "total_distance",
  price = "price",
  originDeadHead = "originDeadHead",
  destinationDeadHead = "destinationDeadHead"
}

export enum PCmiler {
  supportedRegion = "na",
  supportedCountries = "US,CA",
  usePCmilerMaps = "true"
}
export const CHECK_PAYMENT_STATUS_CTA_TEXT = "Check Payment Status";
export const SUBMIT_REQUIRED_PPWK_TEXT = "Submit Required PPWK";
export const RATE_DETAILS_NOTE = "If you have any concerns with this being the proper amount that will be invoiced, then work with Schneider before submitting any invoices to avoid payment delays.";
export const isMyload = (module:any): boolean => {
  return (
    module == MODULES.RECENTLY_DELIVERED_MODULE ||
    module == MODULES.INTRANSIT_MODULE ||
    module == MODULES.DRIVER_ASSIGNED_MODULE ||
    module == MODULES.CARRIER_ASSIGNED_MODULE ||
    module == MODULES.CARRIER_TENDERED_MODULE ||
    (module && module.includes("MyLoad"))
  );
};

export const MAX_ZOOM = 10;
export const REDIRECTION_SCHNEIDER_CARRIER_URL = "schneidercarriers.com";
export const betaToolRedirectionURL = "https://freightpower.schneider.com/parkingAssist";
export const TOP_RECOMMENDED_LOAD_COUNT = 2;
export const REMOVE_MANAGE_CAPACITY_LOADS_RESULTS =
  "REMOVE_MANAGE_CAPACITY_LOADS_RESULTS";

//Remote Config KeyName for ColorCode
export const DEFAULT_BUTTON_COLOR = "#F85F14";
export const CONTACT_DISPATCHER = "Contact your dispatcher.";
export const DRIVER_NO_ROUTES_ERROR = "No routes currently assigned to you.";
export const EMPTY_MYLOADS_BUCKET = "No Routes are currently in this status.";
export const NO_SEARCH_ICON = "no_search_icon";
export const NO_ROUTE_ICON = "no_route_icon";
export const PREFERENCE_UNSAVED_TEXT = "Unsaved Changes";

//Remote Config KeyName for Trailer Alignment
export const LIST_OF_DRIVERS = "List of Drivers";

export const non_managed_equipment_load_question =
  "Utilizing Schneider equipment for the route :";
export const GET_TMS_DOCUMENT = "GET_TMS_DOCUMENT";
export const GET_TMS_DOCUMENTS = "GET_TMS_DOCUMENTS";
export const SAVE_TMS_DOCUMENTS = "SAVE_TMS_DOCUMENTS";
export const CREATE_INVOICE = "CREATE_INVOICE";
export const SUBMIT_INVOICE = "SUBMIT_INVOICE";
export const SAVE_TMS_DOCUMENTS_NEW = "SAVE_TMS_DOCUMENTS_NEW";
export const SUBMIT_INVOICE_NEW = "SUBMIT_INVOICE_NEW";

export const TERMS_CONDITIONS = {
  TERMS_CONDITIONS_HEADER: "Terms & Conditions",
  MANAGED_CONTENT: `<p>It is expected that you will utilize a Schneider owned trailer for this route. You will be required to acquire a trailer at a location specified by Schneider prior to arriving at the shipper.</p><p>A rate confirmation will be sent to you once assigned within the Schneider Transportation Management System. The carrier must follow this documentation, any changes to the route will cause an updated rate confirmation which would include updated payment information.</p><p>This transaction is subject to and governed by the written agreement between you and Schneider Transportation Management, a division of Schneider National Carriers, Inc. and the terms of this site.</p>`,
  UNMANAGED_CONTENT: `<p>It is expected that you will utilize a trailer which you own for this shipment.</p><p>A shipment tender will be sent to you once assigned within the Schneider Transportation Management System. The carrier must follow this tender, any changes to the shipment will cause an updated tender documentation which would include updated payment information.</p><p>This transaction is subject to and governed by the written agreement between you and Schneider Transportation Management, a division of Schneider National Carriers, Inc. and the terms of this site.</p>`,
  MANAGED : "Managed",
  UNMANAGED : "Unmanaged",
};
export enum TRAILER_TYPES {
  TA = "TA",
  SNLU = "SNLU",
  SNCZ = "SNCZ",
  BOBTAIL = "BOBTAIL",
  OTHER = "OTHER"
}

export const CHOOSE_OPTION = "Please select an option!";

export const COMPLETE_REQUIRED_FIELDS = "Please complete all required fields";

export const DEEPLINK_ERR_INVALID = "You have clicked an invalid link";
export const DEEPLINK_ERR_EXPIRED = "The link you've clicked no longer valid";
export enum ESOURCE_TYPE_CHECK {
  VIEW_DOCUMENT_ROLE = "VIEW_DOCUMENT_ROLE",
  UPLOAD_DOCUMENT_ROLE = "UPLOAD_DOCUMENT_ROLE",
  INVOICE_UPLOAD_DOCUMENT_ROLE = "INVOICE_UPLOAD_DOCUMENT_ROLE",
  PAYMENT_STATUS_BUTTON_ROLE = "PAYMENT_STATUS_BUTTON_ROLE",
  AVAILABLE_DOCUMENT_SECTION_ROLE = "AVAILABLE_DOCUMENT_SECTION_ROLE",
  RELATED_DOCUMENT_SECTION_ROLE = "RELATED_DOCUMENT_SECTION_ROLE",
  SCHNEIDER_INVOICE_CREATION_SECTION_ROLE= "SCHNEIDER_INVOICE_CREATION_SECTION_ROLE",
  UPLOAD_DOCUMENT_TYPE = "UPLOAD_DOCUMENT_TYPE"
}
export enum EsourceTMSList {
  LOAD_SOURCE_OTM= "OTMASSET",
  LOAD_SOURCE_MG= "MERCURYGATE",
  LOAD_SOURCE_MM= "MASTERMIND",
  LOAD_SOURCE_SCDM= "OTMNONASSET",
  LOAD_SOURCE_TRINIUM= "TRINIUM"
};
export enum EdivisionList {
  BROKERAGE = "Brokerage",
  POWER_ONLY= "Power Only",
  PO_DRAY= "PO Dray",
  FREIGHT_UNDER_MANAGEMENT="Freight Under Management",
  PORT_DRAY="Port Dray"
}
export const MYLOAD_DOCUMENT_UPLOAD: IUPLOAD_DOCUMENT_CONFIG_FALLBACK = {
  GENERAL_DOCUMENT_CONFIG: {
    [EsourceTMSList.LOAD_SOURCE_MG]: {
      [EdivisionList.BROKERAGE]: {
        [ESOURCE_TYPE_CHECK.VIEW_DOCUMENT_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_ROLE]: [],
        [ESOURCE_TYPE_CHECK.INVOICE_UPLOAD_DOCUMENT_ROLE]: [],
        [ESOURCE_TYPE_CHECK.PAYMENT_STATUS_BUTTON_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.AVAILABLE_DOCUMENT_SECTION_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.RELATED_DOCUMENT_SECTION_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.SCHNEIDER_INVOICE_CREATION_SECTION_ROLE]: [],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_TYPE]: {
          [EUSER_ROLES.carrierDriver]: [],
          [EUSER_ROLES.carrierDispatcher]: [],
          [EUSER_ROLES.carrierLeasedOwnerOpr]: []
        }
      },
    },
    [EsourceTMSList.LOAD_SOURCE_OTM]: null,
    [EsourceTMSList.LOAD_SOURCE_MM]: {
      [EdivisionList.POWER_ONLY]: {
        [ESOURCE_TYPE_CHECK.VIEW_DOCUMENT_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.INVOICE_UPLOAD_DOCUMENT_ROLE]: [EUSER_ROLES.carrierDispatcher],
        [ESOURCE_TYPE_CHECK.PAYMENT_STATUS_BUTTON_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.AVAILABLE_DOCUMENT_SECTION_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.RELATED_DOCUMENT_SECTION_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.SCHNEIDER_INVOICE_CREATION_SECTION_ROLE]: [EUSER_ROLES.carrierBeta1, EUSER_ROLES.carrierDispatcher],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_TYPE]: {
          [EUSER_ROLES.carrierDriver]: [],
          [EUSER_ROLES.carrierDispatcher]: [],
          [EUSER_ROLES.carrierLeasedOwnerOpr]: [],
        }
      },
      [EdivisionList.PO_DRAY]: {
        [ESOURCE_TYPE_CHECK.VIEW_DOCUMENT_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.INVOICE_UPLOAD_DOCUMENT_ROLE]: [EUSER_ROLES.carrierDispatcher],
        [ESOURCE_TYPE_CHECK.PAYMENT_STATUS_BUTTON_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.AVAILABLE_DOCUMENT_SECTION_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.RELATED_DOCUMENT_SECTION_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.SCHNEIDER_INVOICE_CREATION_SECTION_ROLE]: [EUSER_ROLES.carrierBeta1, EUSER_ROLES.carrierDispatcher],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_TYPE]: {
          [EUSER_ROLES.carrierDriver]: [],
          [EUSER_ROLES.carrierDispatcher]: [],
          [EUSER_ROLES.carrierLeasedOwnerOpr]: [],
        }
      }
    },
    [EsourceTMSList.LOAD_SOURCE_SCDM]: {
      [EdivisionList.FREIGHT_UNDER_MANAGEMENT]: {
        [ESOURCE_TYPE_CHECK.VIEW_DOCUMENT_ROLE]: [],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_ROLE]: [],
        [ESOURCE_TYPE_CHECK.INVOICE_UPLOAD_DOCUMENT_ROLE]: [],
        [ESOURCE_TYPE_CHECK.PAYMENT_STATUS_BUTTON_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.AVAILABLE_DOCUMENT_SECTION_ROLE]: [],
        [ESOURCE_TYPE_CHECK.RELATED_DOCUMENT_SECTION_ROLE]: [],
        [ESOURCE_TYPE_CHECK.SCHNEIDER_INVOICE_CREATION_SECTION_ROLE]: [],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_TYPE]: {
          [EUSER_ROLES.carrierDriver]: [],
          [EUSER_ROLES.carrierDispatcher]: [],
          [EUSER_ROLES.carrierLeasedOwnerOpr]: [],
        }
      }
    },
    [EsourceTMSList.LOAD_SOURCE_TRINIUM]: {
      [EdivisionList.PORT_DRAY]: {
        [ESOURCE_TYPE_CHECK.VIEW_DOCUMENT_ROLE]: [],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_ROLE]: [],
        [ESOURCE_TYPE_CHECK.INVOICE_UPLOAD_DOCUMENT_ROLE]: [],
        [ESOURCE_TYPE_CHECK.PAYMENT_STATUS_BUTTON_ROLE]: [EUSER_ROLES.carrierDriver, EUSER_ROLES.carrierDispatcher, EUSER_ROLES.carrierLeasedOwnerOpr],
        [ESOURCE_TYPE_CHECK.AVAILABLE_DOCUMENT_SECTION_ROLE]: [],
        [ESOURCE_TYPE_CHECK.RELATED_DOCUMENT_SECTION_ROLE]: [],
        [ESOURCE_TYPE_CHECK.SCHNEIDER_INVOICE_CREATION_SECTION_ROLE]: [],
        [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_TYPE]: {
          [EUSER_ROLES.carrierDriver]: [],
          [EUSER_ROLES.carrierDispatcher]: [],
          [EUSER_ROLES.carrierLeasedOwnerOpr]: [],
        }
      }
    },
  },
  ADD_DOCUMENT_CONFIG: {
    documentFormat: "image/png, image/jpg, image/jpeg, application/pdf",
    maximumSize: 2048,
    webGalleryButtonTitle: "Add Documents",
    mobileGalleryButtonTitle: "Select from Gallery",
    mobileCameraButtonTitle: "Capture",
    mobileUploadFooterContent:
      "Browse or capture your documents which you want to upload.",
    documentTypeSelectionErrorMessage: "Please select document type",
    preventDocumentUploadBeforeStartTripErrorMesssage: "Please start the trip for document upload.",
    noDocumentTypeAvailableMsg: "No document type available for selection."
  },
  FETCH_DOCUMENT_CONFIG: {
    failureMessage: GENERIC_FAILURE_MESSAGE
  },
  DOCUMENT_TYPE: {
    BOL: {
      name: "Bill of Lading",
      value: "masterBillOfLading"
    },
    LR: {
      name: "Lumper Receipts",
      value: "lumperReceipt"
    },
    ST: {
      name: "Scale Ticket",
      value: "scaleTicket"
    },
    MISC: {
      name: "Miscellaneous",
      value: "miscellaneous"
    },
    POD: {
      name: "Proof of Delivery",
      value: "proofOfDelivery"
    },
    RC: {
      name: "Rate Confirmation",
      value: "rateConfirmation"
    },
    SHPTNDR: {
      name: "Shipment Tender",
      value: "shipmentTender"
    },
    INV: {
      name: "Invoice",
      value: "createInvoice"
    }
  }
};

export const CONTENT_OR_CONFIG_TABLE_MAPPING = {
  Global: {
    tableName: "FPC_APP_CONFIG",
    key: "APP_INIT",
    source: "SNIConfig"
  },
  Document: {
    tableName: "CARRIER_DOCUMENT_SPECS",
    key: "DOCUMENT_CONFIG",
    source: "SNIConfig"
  }
};
export const PREFERENCE_ERROR_MESSAGE ="Your role does not have access to any preference settings."
export let PREFERENCE_TABS = {
  home: 'home',
  search: 'search',
  myLoad: 'myLoad',
  manageMyCapacity: 'manageMyCapacity',
  manageUsers: 'manageUsers',
};
export const PREFERENCE_DATA = [
  {
    ACCORD_TITLE: "View Setting",
    ACCORD_ROLE_FILTER_KEY:"VIEW_SETTING",
    ACORD_CONTENT: [
      {
        CONTENT_TITLE: "Select Default Page for Web",
        OPTION_TYPE: "radio",
        API_KEY: "viewsettings",
        CONTENT_VALUE: [
          {
            OPTION_TITLE: "Home Dashboard",
            OPTION_VALUE: PREFERENCE_TABS.home,
          },
          {
            OPTION_TITLE: "Search",
            OPTION_VALUE: PREFERENCE_TABS.search,
          },
          {
            OPTION_TITLE: "My Loads",
            OPTION_VALUE: PREFERENCE_TABS.myLoad,
          },
          {
            OPTION_TITLE: "Manage Capacity",
            OPTION_VALUE: PREFERENCE_TABS.manageMyCapacity,
          },
          {
            OPTION_TITLE: "Manage Users",
            OPTION_VALUE: PREFERENCE_TABS.manageUsers,
          }
        ]
      },
    ]
  },
  {
    ACCORD_TITLE: "Load Recommendations",
    ACCORD_ROLE_FILTER_KEY:"LOAD_RECOMENDATION",
    ACORD_CONTENT: [
      {
        CONTENT_TITLE: "How would you like to be notified",
        OPTION_TYPE: "checkbox",
        API_KEY: "preferredcontact",
        CONTENT_VALUE: [
          {
            OPTION_TITLE: "Email",
            OPTION_VALUE: "email",
          },
          {
            OPTION_TITLE: "SMS",
            OPTION_VALUE: "sms"
          },
          {
            OPTION_TITLE: "In-App",
            OPTION_VALUE: "inapp-notifications"
          },
          {
            OPTION_TITLE: "None",
            OPTION_VALUE: "none"
          }
        ]
      },
      {
        CONTENT_TITLE: "Choose your time(s)",
        OPTION_TYPE: "checkbox",
        API_KEY: "preferredtime",
        CONTENT_VALUE: [
          {
            OPTION_TITLE: "Early Morning",
            OPTION_VALUE: "Early Morning",
          },
          {
            OPTION_TITLE: "Late Morning",
            OPTION_VALUE: "Late Morning"
          },
          {
            OPTION_TITLE: "Early Afternoon",
            OPTION_VALUE: "Early Afternoon"
          },
          {
            OPTION_TITLE: "Late Afternoon",
            OPTION_VALUE: "Late Afternoon"
          }
        ]
      },
      {
        CONTENT_TITLE: "Choose your day(s)",
        OPTION_TYPE: "checkbox",
        API_KEY: "preferreddaysofweek",
        CONTENT_VALUE: [
          {
            OPTION_TITLE: "Weekdays",
            OPTION_VALUE: "Weekdays",
          },
          {
            OPTION_TITLE: "Weekends",
            OPTION_VALUE: "Weekends"
          },
        ]
      },
    ]
  },
  {
    ACCORD_TITLE: "Status Updates",
    ACCORD_ROLE_FILTER_KEY:"STATUS_UPDATE",
    ACORD_CONTENT: [
      {
        CONTENT_TITLE: "How should we notify you of required status updates",
        OPTION_TYPE: "checkbox",
        API_KEY: "preferredstatusupdates",
        CONTENT_VALUE: [
          {
            OPTION_TITLE: "Email",
            OPTION_VALUE: "email",
          },
          {
            OPTION_TITLE: "SMS",
            OPTION_VALUE: "sms"
          },
          {
            OPTION_TITLE: "In-App",
            OPTION_VALUE: "inapp-notifications"
          }
        ]
      },
    ]
  },
  {
    ACCORD_TITLE: "Capacity Type",
    ACCORD_ROLE_FILTER_KEY:"CAPACITY_TYPE",
    ACORD_CONTENT: [
      {
        CONTENT_TITLE: "Choose default Capacity Type",
        OPTION_TYPE: "radio",
        API_KEY: "preferredcapacitytype",
        CONTENT_VALUE: [
          {
            OPTION_TITLE: "Power Only",
            OPTION_VALUE: "PowerOnly",
          },
          {
            OPTION_TITLE: "Dry Van",
            OPTION_VALUE: "Dryvan",
          },
          {
            OPTION_TITLE: "Dray",
            OPTION_VALUE: "Dray",
          },
          {
            OPTION_TITLE: "Refrigerated",
            OPTION_VALUE: "Refrigerator"
          },
          {
            OPTION_TITLE: "Specialized",
            OPTION_VALUE: "specialized"
          },          
        ]
      },
    ]
  },
  {
    ACCORD_TITLE: "Marketing Communications",
    ACCORD_ROLE_FILTER_KEY:"MARKETING_COMMUNICATIONS",
    ACORD_CONTENT: [
      {
        CONTENT_TITLE: "How should we notify you of general Schneider communications",
        OPTION_TYPE: "checkbox",
        API_KEY: "preferredmarketingcommunications",
        CONTENT_VALUE: [
          {
            OPTION_TITLE: "Email",
            OPTION_VALUE: "email",
          },
          {
            OPTION_TITLE: "SMS",
            OPTION_VALUE: "sms"
          },
          {
            OPTION_TITLE: "In-App",
            OPTION_VALUE: "inapp-notifications"
          },
          {
            OPTION_TITLE: "None",
            OPTION_VALUE: "none"
          }
        ]
      },
    ]
  },
  

]

export const PREFERENCE_API_FALLBACK = {
  userPreferences: [
    {
      value: "home",
      key: "viewsettings",
      domain: null,
      useractionrequired: null,
      userPreferenceExists:null
      
    },
    {
      value: {
        sms: "true",
        email: "true",
        "inapp-notifications": "false"
      },
      key: "preferredcontact",
      domain: null,
      useractionrequired: null,
      userPreferenceExists:null
    },
    {
      value: {
        "Early Morning": "true",
        "Late Morning": "false",
        "Early Afternoon": "true",
        "Late Afternoon": "false"
      },
      key: "preferredtime",
      domain: null,
      useractionrequired: null,
      userPreferenceExists:null
    },
    {
      value: {
        Weekdays: "true",
        Weekends: "false"
      },
      key: "preferreddaysofweek",
      domain: null,
      useractionrequired: null,
      userPreferenceExists:null
    },
    {
      value: "PowerOnly",
      key: "preferredcapacitytype",
      domain: null,
      useractionrequired: null,
      userPreferenceExists:null
    },
    {
      value: {
        sms: "true",
        email: "true",
        "inapp-notifications": "false"
      },
      key: "preferredstatusupdates",
      domain: null,
      useractionrequired: null,
      userPreferenceExists:null
    },
    {
      value: {
        sms: "false",
        email: "true",
        "inapp-notifications": "false"
      },
      key: "preferredmarketingcommunications",
      domain: null,
      useractionrequired: null,
      userPreferenceExists:null
    }
  ],
  userPreferencesDomain: "carrier",
  PreferenceUpdateSuccessMsg: "Preferences updated successfully."
};
export enum EExecutionStatus {
  TRIP_IN_PROGRESS = "Trip In Progress",
  TRIP_COMPLETED = "Trip Completed",
}
export const radioButtonData = [
  {
    value: "NO",
    Display_title: "Schneider will create invoice",
    visibilityKey: "CREATE_SNI_INVOICE_VIEW",
  },
  {
    value: "YES",
    Display_title: "Upload your invoice",
    visibilityKey: "CREATE_OWN_INVOICE_VIEW",
  }
];
export const deLinkHeader = "Delink Account";
export const deLinkContent = "<p>Are you sure? This process cannot be undone.</p><p>Do you want to remove <email_or_number> from carrier <carrier_name>?</p>";
export const invoice_validation_modal_title = "Required trailer information";
export const invoice_validation_modal_message = "Please provide missing trailer information before submitting an invoice.";

export const CAMERA_SOURCE = "CAMERA";
export const STORE_CAPTURE_IMAGE = "STORE_CAPTURE_IMAGE";
export const REMOVE_CAPTURE_IMAGE = "REMOVE_CAPTURE_IMAGE";
export const STORE_MYLOADS_FILTER_COUNT = "STORE_MYLOADS_FILTER_COUNT";
export enum EGPSTrackingStatus {
  GPS_TRACKING_NOT_STARTED = 0,
  GPS_TRACKING_STARTED = 1,
  GPS_TRACKING_COMPLETED = 2,
  GPS_TRACKING_STOPPED = 10
}
export const stopTrackingModalMessage = "Location tracking is required so that we can automatically track the shipments, trigger workflow events on your behalf while the app is in use or backgrounded.Are you sure you want to stop tracking?";
export const stopTrackingModalTitle = "Stop GPS Tracking"; 
export const TRAILER_LEASE_MODAL = {
  "trailer_lease_title": "Trailer Rental",
  "trailer_lease_message": "Click OK to navigate away from Schneider FreightPower.",
  "trailer_lease_redirection_url": "https://www.repowr.com/",
  "trailer_lease_ok_button_title": "OK",
  "trailer_lease_cancel_button_title": "Cancel"
};
export const CountryCodesForUser =  [
  {"US": "+1"},
  {"MX": "+52"}
];
export enum SHIPMENTSTATE {
  NOT_ASSIGNED = "Not Assigned",
  TENDERED = "Tendered",
  PENDING_CARRIER_ASSIGNMENT = "Pending Carrier Assignment",
  CARRIER_ASSIGNMENT = "Carrier Assignment",
  PENDING_DRIVER_UNASSIGNMENT = "Pending Driver Un-Assignment",
  PENDING_DRIVER_ASSIGNMENT = "Pending Driver Assignment",
  DRIVER_ASSIGNMENT = "Driver Assignment"  ,
  PENDING_TENDER_DECLINED = "Pending Tender Declined" ,
  IN_TRANSIT = "In Transit",
  DELIVERED_NEEDS_PPWK = "Delivered Needs Docs",
  DELIVERED_WITH_PPWK = "Delivered With Docs",
}
export enum MANAGE_USERS_TOOLTIP_NAME {
  DRIVER_ASSIGNED = "Driver Assigned",
  IN_TRANSIT = "In-Transit",
  DELIVERED_NEEDS_PPWK = "Delivered Needs PPWK",
  DELIVERED_WITH_PPWK = "Delivered With PPWK",
}
export const ACCEPT_LOAD_TEXT = "Accept Load";
export const accept_load_modal_title = "Accept Load";
export const accept_load_modal_message = "Do you want to accept the load?"
export const declined_load_modal_title = "Decline Load";
export const declined_load_modal_message = "Do you want to decline the load?"
export const declineReasonCode = "DeclineReason";
export const ACCEPT_ACTION_TYPE = "tenderAccept";
export const ACCEPT_ACTION_QUALIFIER = "Pro Number";
export const ACCEPT_ACTION = "Accept";
export const DECLINE_ACTION_TYPE = "tenderDecline";
export const DECLINE_ACTION_QUALIFIER = "DECLINE"; 
export const DECLINE_ACTION = "Decline";
export const CARRIER_PRO = "Carrier PRO (Optional)";
export const TENDER_ACTION_DEFAULT_TIMEZONE = "US/Central";
export const TENDER_DECLINE_SUCCESS_MESSAGE = "Tender Declined Successfully";
export const TENDER_ACCEPT_SUCCESS_MESSAGE = "Tender Accepted Successfully";
export const TENDERED_COUNT_MESSAGE = "Tendered";
export const LEASED_ON_OWNER_OPERATOR_ROLE = "Leased on Owner Operator";
export const ADMIN = "Admin";
export const BETA = "Beta";
export const GUEST = "Guest";
export const ADD_REFERENCE_SUCCESS = "Reference added successfully";
export const ADD_REFERENCE = "ADD_REFERENCE";
export const ADD_REFERENCE_DATA = "ADD_REFERENCE_DATA";
export const REFERENCE_ACTION_TYPE = "refUpdate";
export const REFERENCE_ACTION_DETAIL = "Tendered Bucket";
export const addReferenceModal: IAddReferenceData[] = [{
  "MERCURYGATE": {
    "visible": {}
  },
  "MASTERMIND": {
    "visible": {}
  },
  "OTMNONASSET": {
    "visible": {
        "Freight Under Management": {
          "references": [
            "Master Bill of Lading",
            "Pro Number",
            "Reported Hours",
            "Trailer"
          ]
        }
      }
  },
  "TRINIUM": {
    "visible": {}
  }
}];
export const LATE_REASON_CODE_MODAL_TITLE = "Late Reason Code";
export const LATE_REASON_CODE_MODAL_MESSAGE = "You arrived late - select the reason from the list below.";
export const LATE_REASONCODE_MODAL_CONFIG_FALLBACK : LATE_REASONCODE_MODAL_CONFIG = {
  [EsourceTMSList.LOAD_SOURCE_MG]: {
    "VISIBILITY": [],
    "GRACE_PERIOD": {},
    "REASON_CODES": {}
  },
  [EsourceTMSList.LOAD_SOURCE_MM]: {
    "VISIBILITY": [],
    "GRACE_PERIOD": {},
    "REASON_CODES": {}
  },
  [EsourceTMSList.LOAD_SOURCE_SCDM]: {
    "VISIBILITY": [
      "Freight Under Management"
    ],
    "GRACE_PERIOD": {
      "Freight Under Management": 0
    },
    "REASON_CODES": {
      "Freight Under Management": [
        {
          "key": "A01_MISSED DELIVERY",
          "value": "Missed Delivery"
        },
        {
          "key": "A05_UNABLE TO LOCATE",
          "value": "Unable to Locate"
        },
        {
          "key": "A09_DAMAGED-DELIVERY COMPLETED",
          "value": "Damaged-Delivery Completed"
        },
        {
          "key": "A10_DAMAGED-DELIVERY NOT COMPLETED",
          "value": "Damaged-Delivery Not Completed"
        },
        {
          "key": "A24_ACCIDENT",
          "value": "Accident"
        },
        {
          "key": "A27_DRIVER RELATED",
          "value": "Driver Related"
        },
        {
          "key": "A30_MECHANICAL BREAKDOWN",
          "value": "Mechanical Breakdown"
        },
        {
          "key": "A31_ARRIVED IN STATION AFTER COURIER DISPATCH",
          "value": "Arrived in Station After Courier Dispatch"
        },
        {
          "key": "A33_NO CAPACITY CONTRACTED CARRIER",
          "value": "No Capacity Contracted Carrier"
        },
        {
          "key": "A45_DELIVERY NOT COMPLETED",
          "value": "Delivery Not Completed"
        },
        {
          "key": "A74_PACKAGE DELIVERED AFTER COMMITMENT",
          "value": "Package Delivered After Commitment"
        },
        {
          "key": "A91_EXCEEDS SERVICE LIMITATIONS",
          "value": "Exceeds Service Limitations"
        },
        {
          "key": "A95_PAST CUTOFF TIME",
          "value": "Past Cutoff Time"
        },
        {
          "key": "A98_MISSED PICK UP",
          "value": "Missed Pick Up"
        },
        {
          "key": "BO1_RAILROAD FAILED TO MEET SCHEDULE",
          "value": "RailRoad Failed to Meet Schedule"
        },
        {
          "key": "BR1_TRAIN DERAILMENT",
          "value": "Train Derailment"
        },
        {
          "key": "D01_CARRIER DISPATCH ERROR",
          "value": "Carrier Dispatch Error"
        },
        {
          "key": "D02_DRIVER NOT AVAILABLE",
          "value": "Driver Not Available"
        },
        {
          "key": "P01_PROCESSING DELAY",
          "value": "Processing Delay"
        },
        {
          "key": "P02_WAITING INSPECTION",
          "value": "Waiting Inspection"
        },
        {
          "key": "T03_TRAILER NOT AVAILABLE",
          "value": "Trailer Not Available"
        },
        {
          "key": "T04_EQUIPMENT REJECT",
          "value": "Equipment Reject"
        }
      ]
    }
  },
  [EsourceTMSList.LOAD_SOURCE_TRINIUM]: {
    "VISIBILITY": [],
    "GRACE_PERIOD": {},
    "REASON_CODES": {}
  },
  [EsourceTMSList.LOAD_SOURCE_OTM]: {
    "VISIBILITY": [],
    "GRACE_PERIOD": {},
    "REASON_CODES": {}
  }
}
export const CARRIER_TENDERED_LOAD_BUTTON_FALLBACK = {
  "MERCURYGATE": {
    "Accept": [],
    "Decline": [],
    "REASON_CODES": {},
    "CARRIER_PRO" : []
  },
  "MASTERMIND": {
    "Accept": [],
    "Decline": [],
    "REASON_CODES": {},
    "CARRIER_PRO" : []
  },
  "OTMNONASSET": {
    "Accept": [
      "Freight Under Management"
    ],
    "Decline": [
      "Freight Under Management"
    ],
    "REASON_CODES": {
      "Freight Under Management": [
        {
          "name": "AC_NEXT DAY PU TENDERED AFTER CUTOFF",
          "value": "Next Day PU Tendered After Cutoff"
        },
        {
          "name": "CC_CAPACITY CONSTRAINTS",
          "value": "Capacity Constraints"
        },
        {
          "name": "DL_DELIVERY TIME TOO TIGHT",
          "value": "Delivery Time Too Tight"
        },
        {
          "name": "EC_EQUIPMENT CONSTRAINTS",
          "value": "Equipment Constraints"
        },
        {
          "name": "ET_TYPE OF EQUIPMENT",
          "value": "Type of Equipment"
        },
        {
          "name": "LH_LENGTH OF HAUL UNDESIRABLE",
          "value": "Length of Haul Undesirable"
        },
        {
          "name": "LT_INSUFFICIENT LEAD TIME",
          "value": "Insufficient Lead Time"
        },
        {
          "name": "NT_NO TEAM AVAILABLE",
          "value": "No Team Available"
        },
        {
          "name": "OS_OUTSIDE SERVICE AREA",
          "value": "Outside Service Area"
        },
        {
          "name": "PE_PERMITS",
          "value": "Permits"
        },
        {
          "name": "SU_SHIPMENT UPDATE",
          "value": "Shipment Update"
        },
        {
          "name": "WT_WEIGHT",
          "value": "Weight"
        }
      ]
    },
    "CARRIER_PRO" : [
      "Freight Under Management"
    ]
  },
  "TRINIUM": {
    "Accept": [],
    "Decline": [],
    "REASON_CODES": {},
    "CARRIER_PRO" : []
  }
};
 
export const DefaultPODrayContactFallback = "<a href='tel:9999999999'>9999999999</a>";

export const DECLINE_REASON_CODE_MESSAGE = "Enter Decline Reason Code";
export const showMoreButtonVisiblityValue = "yes";
export const REFERENCE_TYPE_HEADER_MESSAGE = "Please select your reference type";
export const REFERENCE_TYPE_MESSAGE = "Select Reference Type";
export const REFERENCE_VALUE_PLACEHOLDER_MESSAGE = "Type your value here";
export const LO3_ASSIGN_DRIVER_HEADER_MESSAGE ="Confirm loadId assignment to Driver";

export const MyLoadsConfigFallback:any = {
  "PageSize": {
    "Web": 99,
    "Mobile": 99
  },
  "DriverFilterVisibility": {
    "Web": false,
    "Mobile": false
  }
}

export const NEVER_LOGGED_IN ="Never Logged In";
export const RE_SEND_INVITE_MODAL_TITLE = "Invite Sent";
export const RE_SEND_INVITE_MODAL_MESSAGE = "Invite Sent to the email and phone number provided for the new user";
export const RE_SEND_INVITE_SUCCESS_MESSAGE = "Invite Sent";
export const RE_SEND_INVITE_FAILURE_MESSAGE = "Invite could not be Sent";
export const RE_SEND_INVITE_BUTTON_NAME = "Ok";

export const APPOINTMENT_MODAL_TITLE = "Unconfirmed Appointments";
export const APPOINTMENT_MODAL_MESSAGE = "<p>This route has the following warnings.Please confirm that you move the load by clicking Agree.</p><p><b>This route has unconfirmed appointments</b></p>";
export const APPOINTMENT_TOOLTIP_MESSAGE = "Appointment not confirmed";
export const APPOINTMENT_MODAL_BUTTON_NAME = "Agree";

export const GET_MEMBERS_CONFIG = { 
    "page": "0",
    "size": "999",
    "sort": "createdAt:d"
};
export const APPOINTMENT_INDICATOR_STATE_VALUE = "P";
export const CARRIER_PRO_TYPE = "CARRIER_PRO";
export const SAME_DAY_PICKUP_POPUP_TITLE = "Same Day Pick Up";
export const SAME_DAY_PICKUP_POPUP_MESSAGE = "<p>This route has the following warnings.Please confirm that you move the load by clicking Agree.</p><p><b>This route picks up today</b></p>";
export const SAME_DAY_PICKUP_MODAL_TYPE ="same_day_pickup";
export const APPOINTMENT_MODAL_TYPE = "unconfirmed_appointments";
export const GENERIC_PRE_BOOK_NOW_POPUP_TITLE = "Warning";
export const GENERIC_PRE_BOOK_NOW_POPUP_MESSAGE = "<p>This route has the following warnings.Please confirm that you move the load by clicking Agree.</p><p><b>This route has unconfirmed appointments</b></p><p><b>This route picks up today</b></p>";
export const NO_SERVICES_TEXT = "No services available";
export const FEEDBACK_CONTENT = "<p><strong>How likely are you to recommend Schneider FreightPower&nbsp;App?&nbsp;</strong></p>\n<p>Feedback about your experience is important and will help us continue to improve.&nbsp;</p>\n<p><br></p>\n<p><br></p>";
export const BORDER_CROSSING = "BorderCrossing";
export const RELAY = "Relay";
export const COVERING_USER = "COVERING USER";
export const REASON_CODES = "REASON_CODES";
export const restrict_LO3_user_modal_title = "Confirm Role Selection";
export const restrict_LO3_user_modal_message = "<p>Leased On Owner Operator may not be combined with any other user types.</p><p>Proceeding with Leased On Owner Operator role selection will result in removal of all other role types in this request. Want to continue?</p>";
export const ASSIGNED_LOAD_DETAILS = "Assigned Load Details";
export const ASSIGNED_LOADS = "Assigned Loads";
export const ManageUsersConfigFallback:any = {
  "PageSize": {
    "Web": 3,
  },
  "DriverFilterVisibility": {
    "Web": false,
  }
};


export const FPC_MANAGE_USER_ROLES_WEB_FALLBACK ="[{\"label\":\"Beta\",\"value\":\"carrierBeta1\",\"desc\":\"Tests and provides feedback for software in pre-launch.\",\"selected\":false,\"displayFlag\":false},{\"label\":\"Admin\",\"value\":\"carrierAdmin\",\"desc\":\"Manages carrier user(s) roles and privileges.\",\"selected\":false,\"displayFlag\":false},{\"label\":\"Guest\",\"value\":\"carrierGuest\",\"desc\":\"Limited access permissions.\",\"selected\":false,\"displayFlag\":false},{\"label\":\"Driver\",\"value\":\"carrierDriver\",\"desc\":\"Carry and update the status of loads.\",\"selected\":false,\"displayFlag\":true},{\"label\":\"Dispatcher\",\"value\":\"carrierDispatcher\",\"desc\":\"Search, book, carry and update the status of loads.\",\"selected\":false,\"displayFlag\":true},{\"label\":\"Leased on Owner Operator\",\"value\":\"carrierLeasedOwnerOpr\",\"desc\":\"Search, book, carry and update loads for themselves.\",\"selected\":false,\"displayFlag\":true}]";
export const FPC_MANAGE_USER_ROLES_FALLBACK = "[{\"label\":\"Driver\",\"value\":\"carrierDriver\",\"desc\":\"Carry and update the status of loads.\",\"selected\":false,\"displayFlag\":true},{\"label\":\"Dispatcher\",\"value\":\"carrierDispatcher\",\"desc\":\"Search, book, carry and update the status of loads.\",\"selected\":false,\"displayFlag\":true},{\"label\":\"Leased on Owner Operator\",\"value\":\"carrierLeasedOwnerOpr\",\"desc\":\"Search, book, carry and update loads for themselves.\",\"selected\":false,\"displayFlag\":true}]";
export const ROLE_CONFIRMATION_LOO_FALLBACK = "{\"title\":\"Confirm Role Selection\",\"message\":\"<p>Leased On Owner Operator may not be combined with any other user types.</p><p>Proceeding with Leased On Owner Operator role selection will result in removal of all other role types in this request. Want to continue?</p>\",\"primaryButtonTitle\":\"No\",\"secondaryButtonTitle\":\"Yes\"}";
export const PORTDRAY_CONTACT_INFO_FALLBACK = "{\"carrierPhone\": \"855-229-3217\",\"carrierName\": \"\",\"carrierEmail\": \"PortDrayCapacity@schneider.com\"}";
export const DEFAULT_UPLOAD_DOCUMENT_TYPE = "miscellaneous";
export const CAPACITY_TYPE_DRAY = "Dray";
export const CAPACITY_TYPE_POWERONLY = "Power Only";
export const MY_DRIVER_SHIPMENTS = "myDriverShipments";
export const CONTACT_DETAILS_NOT_FOUND = "Contact Details Not Found";

export const START_LOCATION_AND_TIME = {
  "MERCURYGATE": {
    "DEFAULT": [],
    "EMPTY": [
      "Brokerage"
    ]
  },
  "MASTERMIND": {
    "DEFAULT": ["PO Dray"],
    "EMPTY": [
      "Power Only"
    ]
  },
  "OTMNONASSET": {
    "DEFAULT": [],
    "EMPTY ": [
      "Freight Under Management"
    ]
  },
  "TRINIUM": {
    "DEFAULT": [],
    "EMPTY": [
      "Port Dray"
    ]
  }
};
export const DRIVER_GAP_FILL_IN_ACTIONS = [
  {
  "label": "Carrier Assigned",
  "path": "/app/MyLoad/CarrierAssigned",
  "icon": "bucket.svg",
  "slug": "carrier_assigned"
  },
  {
  "label": "Post Truck",
  "path": "/app/manage-capacity/add",
  "icon": "truck.svg",
  "slug": "post_truck"
  }
 ];
 export const CANCEL_TEXT_FOR_IONDATETIME = "Cancel";
 export const DONE_TEXT_FOR_IONDATETIME = "Done";
 export const COLOR_FOR_IONDATETIME = "dark";
export const PCMILLER_REQUEST = "PCMILLER_REQUEST";
 export const PCMILLER_DATA = "PCMILLER_DATA";
 export const ADJUST = "adjust";